import { minWidth } from "@mui/system";

export const getAllPaymentMethod = () => {
  return [
    { title: "Cash", value: "Cash" },
    { title: "Card", value: "Card" },
    { title: "UPI", value: "UPI" },
    { title: "Cheque", value: "Cheque" },
    { title: "RTGS", value: "RTGS" },
  ];
};
export const getAllPaymentMethodForNoInovice = () => {
  return [
    { title: "Cash", value: "Cash" },
    { title: "Metal", value: "Metal" },
    { title: "Metal to Cash", value: "Metal to Cash" },
    { title: "Cash to Metal", value: "Cash to Metal" },
  ];
};
export const advanceAmountMethods = () => {
  return [
    { title: "Cash", value: "Cash" },
    { title: "Card", value: "Card" },
    { title: "UPI", value: "UPI" },
    { title: "Cheque", value: "Cheque" },
    { title: "RTGS", value: "RTGS" },
  ];
};

export const metals = () => {
  return [
    // {title:"GOLD",value:"Gold"},
    // {title:"SILVER",value:"Silver"},
    // {title:"PLATINUM",value:"Platinum"},
    { title: "PURE GOLD", value: "Pure Gold" },
    { title: "PURE SILVER", value: "Pure Silver" },
    { title: "OLD GOLD", value: "Old Gold" },
    { title: "OLD SILVER", value: "Old Silver" },
  ];
};
export const goldCategoryIds = [
  1, // GOLD
  4, // PURE GOLD
  6, // OLD GOLD
  9, // DIAMOND GOLD
];
export const silverCategoryIds = [
  2, // GOLD
  5, // PURE GOLD
  7, // OLD GOLD
  11, // DIAMOND SILVER
];
export const filtermetals = (skus) => {
  console.log("working");
  console.log(skus);

  if (
    skus?.length &&
    goldCategoryIds?.includes(skus[0]?.CategoryId?.value || skus[0]?.CategoryId)
  ) {
    return [
      { title: "PURE GOLD", value: "Pure Gold" },
      { title: "OLD GOLD", value: "Old Gold" },
    ];
  }
  if (
    skus?.length &&
    silverCategoryIds?.includes(
      skus[0]?.CategoryId?.value || skus[0]?.CategoryId
    )
  ) {
    return [
      { title: "PURE SILVER", value: "Pure Silver" },
      { title: "OLD SILVER", value: "Old Silver" },
    ];
  }

  // return [
  //   // {title:"GOLD",value:"Gold"},
  //   // {title:"SILVER",value:"Silver"},
  //   // {title:"PLATINUM",value:"Platinum"},
  //   { title: "PURE GOLD", value: "Pure Gold" },
  //   { title: "PURE SILVER", value: "Pure Silver" },
  //   { title: "OLD GOLD", value: "Old Gold" },
  //   { title: "OLD SILVER", value: "Old Silver" },
  // ];
};

export const getFormattedDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Add leading zero
  const day = String(today.getDate()).padStart(2, "0"); // Add leading zero
  return `${year}/${month}/${day}`;
};

export const DiamondFields = [
  "VendorName",
  "TotalFineGold",
  "TotalFineSilver",
  "advanceamount",
  "balanceamount",
  "StockKeepingUnit",
  "CategoryId",
  'DiamondName',
  "DiamondShape",
  "DiamondColour",
  "DiamondClarity",
  "DiamondSleve",
  "DiamondSize",
  "DiamondWeight",
  "DiamondPieces",
  "DiamondRate",
  "DiamondAmount",
  "DiamondCut",
  "DiamondSettingType",
  "DiamondCertificate",
  "DiamondPacket",
  "DiamondBox",
  "DiamondDescription",
];
export const StoneFields = [
  "VendorName",
  "TotalFineGold",
  "TotalFineSilver",
  "advanceamount",
  "balanceamount",
  "StockKeepingUnit",
  "CategoryId",
  "StoneName",
  "StoneShape",
  "StoneColour",
  "StoneSize",
  "StoneWeight",
  "StoneRateCt",
  "StonePieces",
  "StoneRatePc",
  "StoneAmount",
  "StoneSettingType",
  "StoneCertificate",
  "StonePacket",
  "Box",
  "StoneDescription",
];
export const GeneralFields = [
  "VendorName",
  "TotalFineGold",
  "TotalFineSilver",
  "advanceamount",
  "balanceamount",
  "StockKeepingUnit",
  "CategoryId",
  "ProductId",
  "DesignId",
  "PurityId",
  "TotalWt",
  "PackingWeight",
  "GrossWt",
  "StoneWt",
  "DiamondWeight",
  "NetWt",
  "Qty",
  "MetalRate",
  "FinePercent",
  "WastagePercent",
  "MakingPerGram",
  "MakingFixedWastage",
  "MakingFixedAmt",
  "StonePieces",
  "StoneAmount",
  "Hallmark",
  "ClipQty",
  "ClipWt",
  "TagWt",
  "FindingWt",
  "LanyardWt",
  "MetalAmount",
  "TotalMakingAmount",
  "TotalItemAmount",
  "FineWt",
  "WastageWt",
  "FineWastageWt",
  "Testing",
  "images",
  "Stone",
  "Diamond",
];

export function generateDropDownList({
  field,
  dropdownListData,
  CategoryId,
  ProductId,
  DesignId,
  PurityId,
  skus = [],
  VendorName = {},
  allCollections = [],
  allPackets = [],
  allBoxes = [],
  vendorList = [],
  mainStoneList = [],
  weightCategoryList = [],
  oldGoldPurchase
}) {
  console.log(vendorList);
  console.log(dropdownListData);
  console.log(field);
  console.log(oldGoldPurchase);
  const list =
    field.key === "StockKeepingUnit" || field.key === "SKUId"
      ? Array.isArray(dropdownListData?.allSku)
        ? dropdownListData?.allSku?.filter((item) => {
            let result = false;
            item?.SKUVendor?.map((skItem) => {
              if (skItem?.VendorId == VendorName?.value) {
                result = true;
              }
            });
            if (result) {
              return item;
            }
          })
        : []
      : field.key === "CategoryId"
      ? Array.isArray(dropdownListData?.categories)
        ? skus?.length && !oldGoldPurchase
          ? dropdownListData?.categories?.filter(
              (item) =>
                item?.Id == skus[0]?.CategoryId?.value ||
                item?.Id == skus[0]?.CategoryId
            )
          : 
          oldGoldPurchase 
           ? 
          dropdownListData?.categories?.filter((item)=>item?.Id == oldGoldId || item?.Id == oldSilverId) : 
           dropdownListData?.categories
        : []
      : (field.key === "ProductId")
      ? Array.isArray(dropdownListData?.productTypes)
        ? dropdownListData.productTypes?.filter(
            (item) => item?.CategoryId == CategoryId?.value
          )
        : []
      : field.key === "DesignId"
      ? Array.isArray(dropdownListData?.designs)
        ? dropdownListData.designs?.filter(
            (item) =>
              item?.CategoryId == CategoryId?.value &&
              item?.ProductId == ProductId?.value
          )
        : []
      : field.key === "PurityId"
      ? Array.isArray(dropdownListData?.purities)
        ? dropdownListData.purities?.filter(
            (item) => item?.CategoryId == CategoryId?.value
          )
        : []
      : field.key === "DiamondName"
      ? Array.isArray(dropdownListData?.productTypes)
      ? dropdownListData.productTypes?.filter(
          (item) => item?.CategoryId == CategoryId?.value
        )
        : []
      : field.key === "DiamondShape"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondShape"
          )
        : []
      : field.key === "DiamondClarity"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondClarity"
          )
        : []
      : field.key === "DiamondColour"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondColour"
          )
        : []
      : field.key === "DiamondSleve"
        ? Array.isArray(dropdownListData?.diamondAttributes)
          ? dropdownListData.diamondAttributes?.filter(
              (item) => item?.DiamondAttribute == "DiamondSleve"
            )
          : [] 
     : field.key === "DiamondSize"
          ? Array.isArray(dropdownListData?.diamondAttributes)
            ? dropdownListData.diamondAttributes?.filter(
                (item) => item?.DiamondAttribute == "DiamondSize"
              )
            : [] 
      : field.key === "DiamondSleveGroup"
            ? Array.isArray(dropdownListData?.diamondAttributes)
              ? dropdownListData.diamondAttributes?.filter(
                  (item) => item?.DiamondAttribute == "DiamondSleveGroup"
                )
              : []             
      : field.key === "DiamondCut"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondCut"
          )
        : []
      : field.key === "DiamondSettingType"
      ? Array.isArray(dropdownListData?.diamondAttributes)
        ? dropdownListData.diamondAttributes?.filter(
            (item) => item?.DiamondAttribute == "DiamondSettingType"
          )
        : []
      : field.key === "CollectionId"
      ? Array.isArray(allCollections)
        ? allCollections?.map((item) => item)
        : []
      : field.key === "PacketId"
      ? Array.isArray(allPackets)
        ? allPackets?.map((item) => item)
        : []
      : field.key === "BoxId"
      ? Array.isArray(allBoxes)
        ? allBoxes?.map((item) => item)
        : []
      : field.key === "mainstone"
      ? Array.isArray(mainStoneList)
        ? mainStoneList?.map((item) => item)
        : []
      : field.key === "WeightCategory"
      ? Array.isArray(weightCategoryList)
        ? weightCategoryList?.map((item) => item)
        : []
      : field.key === "Gender"
      ? Array.isArray([])
        ? []?.map((item) => item)
        : []
      : field.key === "StoneName"
      ? Array.isArray(dropdownListData?.stonesList)
        ? dropdownListData?.stonesList
        : []
      : field.key === "StoneColour"
      ? Array.isArray(dropdownListData?.stoneAttributes)
        ? dropdownListData?.stoneAttributes?.filter(
            (item) => item?.StoneAttribute == "StoneColor"
          )
        : []
      : field.key === "StoneShape"
      ? Array.isArray(dropdownListData?.stoneAttributes)
        ? dropdownListData?.stoneAttributes?.filter(
            (item) => item?.StoneAttribute == "StoneShape"
          )
        : []
      : field.key === "StoneSize"
      ? Array.isArray(dropdownListData?.stoneAttributes)
        ? dropdownListData?.stoneAttributes?.filter(
            (item) => item?.StoneAttribute == "StoneSize"
          )
        : []
      : field.key === "VendorId"
      ? Array.isArray(vendorList)
        ? vendorList
        : []
      : [];

      if (field.key == "StoneName"){

        console.log(list)
      }

  const result = list?.map((item) => {
    if (field.key === "StockKeepingUnit" || field.key === "SKUId") {
      return { value: item?.Id, label: item?.StockKeepingUnit };
    }
    if (field.key === "CategoryId") {
      
      return { value: item?.Id, label: item?.CategoryName };
    }
    if (field.key === "ProductId") {
      return { value: item?.Id, label: item?.ProductName };
    }
    if (field.key === "DesignId") {
      return { value: item?.Id, label: item?.DesignName };
    }
    if (field.key === "PurityId") {
      return { value: item?.Id, label: item?.PurityName };
    }
    if(field.key == "DiamondName"){
      return { value: item?.Id, label: item?.ProductName }
    }
    if (
      
      field.key === "DiamondShape" ||
      field.key === "DiamondColour" ||
      field.key === "DiamondClarity" ||
      field.key === "DiamondSleve" ||
      field.key === "DiamondSize" ||
      field.key === "DiamondSleveGroup" ||
      field.key === "DiamondCut" ||
      field.key === "DiamondSettingType"
    ) {
      return { value: item?.Id, label: item?.DiamondValue };
    }
    if (
      field.key === "StoneColour" ||
      field.key === "StoneShape" ||
      field.key === "StoneSize"
    ) {
      return { value: item?.Id, label: item?.StoneValue };
    }
    if (field.key == "CollectionId") {
      return {
        label: item?.Collection?.CollectionName,
        value: item?.Collection?.Id,
      };
    }
    if (field.key == "PacketId") {
      return {
        label: item?.PacketName,
        value: item?.Id,
      };
    }
    if (field.key == "BoxId") {
      return {
        label: item?.BoxName,
        value: item?.Id,
      };
    }
    if (field.key == "VendorId") {
      return {
        label: item?.VendorName,
        value: item?.Id,
      };
    }
    if (field.key == "mainstone") {
      return {
        label: item?.StoneMainName,
        value: item?.Id,
      };
    }
    if (field.key == "WeightCategory") {
      return {
        label: item?.label,
        value: item?.value,
      };
    }
    if (field.key == "StoneName") {
      return {
        label: item?.StoneName,
        value: item?.StoneName,
      };
    }
  });

  if(field?.key == "StoneName"){
    console.log([{ value: "", label: "--select--" }, ...result])
  }
  return [{ value: "", label: "--select--" }, ...result];
}

export const HeadersForAllCategory = [
  "Item Details",
  "Total Wt",
  "Gross Wt",
  "Stone Wt",
  "Net Wt",
  "Fine %",
  "Wastage %",
  "F+W Wt",
  "Rate/Gm",
  "Stone Amt",
  "Qty",
  "HallMark Amt",
  "Total Item Amt",
  "Packing Wt",
  "Diamond Wt",
];

export const HeadersForStones = [
  "Item Details",
  "Stone Name	",
  "Shape",
  "Color",
  "Size",
  "Weight",
  "Rate/karate",
  "Pieces",
  "Rate/Piece",
  "Amount",
  "Setting Type",
  "Certificate",
  "Description",
];

export function getPurchaseEntryFormData({
  data,
  selectedFiles,
  vendorlist,
  clientCode,
  invoiceDate,
  CompanyId,
  CounterId,
  BranchId,
  EmployeeId,
}) {
  console.log(data);
  const formData = new FormData();
  const dateToSend = invoiceDate || getTodaysDateFormat();
  let totalWtReceive = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.FineWt) || 0) + (parseFloat(item2?.FineWt) || 0),
    0
  );
  let totalHallmarkAmt = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.Hallmark) || 0) + parseFloat(item2?.Hallmark || 0),
    0
  );
  let totalTagWeight = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.TagWt) || 0) + parseFloat(item2?.TagWt || 0),
    0
  );
  let totalFindingWeight = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.FindingWt) || 0) + parseFloat(item2?.FindingWt || 0),
    0
  );
  let totalLanyardWeight = data?.skus?.reduce(
    (item1, item2) =>
      (parseFloat(item1?.LanyardWt) || 0) + parseFloat(item2?.LanyardWt || 0),
    0
  );

  let unlabelledSilverWeight = data?.skus
    ?.filter(
      (x) =>
        !x.unlabeled && x?.CategoryId?.label.toLowerCase().includes("silver")
    )
    .reduce((total, product) => total + parseFloat(product.FineWt), 0);

  let unlabelledGoldWeight = data?.skus
    .filter(
      (x) =>
        !x.unlabeled && x?.CategoryId?.label?.toLowerCase().includes("gold")
    )
    .reduce((total, product) => total + parseFloat(product.FineWt), 0);

  let unlabelledOtherMetalWeight = data?.skus
    ?.filter(
      (x) =>
        !x.unlabeled &&
        !x.CategoryId?.label?.toLowerCase().includes("silver") &&
        !x.CategoryId?.label?.toLowerCase().includes("gold")
    )
    .reduce((total, product) => total + parseFloat(product.FineWt), 0);

  let totalStoneWeight = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Stones.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.StoneWeight || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalStoneAmount = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Stones.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.StoneAmount || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalStonePieces = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Stones.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.StonePieces || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalDiamondWeight = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Diamonds.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.DiamondWeight || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalDiamondPieces = data?.skus?.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Diamonds.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone?.DiamondPieces || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);

  let totalDiamondAmount = data?.skus.reduce((totalProductWeight, product) => {
    let productStoneWeight = product.Diamonds.reduce(
      (totalStoneWeight, stone) => {
        return totalStoneWeight + parseFloat(stone.DiamondAmount || 0);
      },
      0
    );
    return totalProductWeight + productStoneWeight;
  }, 0);
  let totalNetWt =  data?.skus?.reduce((acc,product)=>{
         return acc + (+(product?.NetWt) || 0)
  },0)
  let totalDiamondNetWt =  data?.skus?.reduce((acc,product)=>{
    return acc + (+(product?.DiamondWeight) || 0)
},0)
  console.log(totalDiamondNetWt)
  formData.append(
    "TotalNetAmount",
    parseFloat(data?.TotalTaxableAmount || 0).toFixed(3)
  );

  formData.append("TotalGSTAmount", parseFloat(data?.TotalGst || 0).toFixed(3));
  formData.append(
    "TotalPurchaseAmount",
    parseFloat(data?.TotalBillAmount || 0).toFixed(3)
  );
  formData.append(
    "PurchaseStatus",
    data?.paymentTypes?.length > 0 ? "Partial" : "None"
  );
  formData.append("Quantity", data?.Quantity || 0);
  formData.append(
    "PurchaseAmount",
    parseFloat(data?.TotalBillAmount || 0).toFixed(3)
  );
  formData.append("VendorId", data?.VendorName?.value || "");
  formData.append("GSTApplied", data?.gstCheckbox); //  what is gst applied
  formData.append(
    "AdditionTaxApplied",
    data?.additionalTaxCheckbox ? "true" : "false"
  );
  formData.append("Branch", "Home"); //
  formData.append("PurchaseType", "Purchase"); //
  formData.append(
    "Discount",
    parseFloat(data?.TotalRODiscount || 0).toFixed(3)
  ); //
  formData.append("CourierCharge", data?.CourierCharge);
  formData.append("Remark", "");
  formData.append(
    "BalanceGold",
    parseFloat(data?.TotalBalanceMetal || 0).toFixed(3)
  ); // we have  metal balance
  formData.append(
    "BalanceSilver",
    parseFloat(data?.TotalBalanceMetal || 0).toFixed(3)
  ); // we have  fine metal
  formData.append(
    "BalanceAmount",
    parseFloat(data?.TotalBalanceAmount || 0).toFixed(3)
  );
  formData.append("BalanceOtherMetal", "0");
  formData.append("DebitAmount", "0");
  formData.append("DebitGold", "0");
  formData.append("DebitSilver", "0");
  formData.append("DebitOtherMetal", "0");
  formData.append(
    "TotalFineGold",
    parseFloat(data?.TotalFineMetal || 0).toFixed(3)
  ); // we have  fine metal
  formData.append(
    "TotalFineSilver",
    parseFloat(data?.TotalFineMetal || 0).toFixed(3)
  ); // we have  fine metal
  formData.append("TotalFineOtherMetal", "0");
  formData.append("InvoiceNo", data?.invoiceNumber || "");
  if (false) {
    // selectedFiles.length > 0
    selectedFiles.forEach((file) => {
      formData.append("InvoiceFile", file);
    });
  } else {
    formData.append("InvoiceFile", "");
  }
  const vndr = vendorlist?.find((item) => item?.Id == data?.VendorName?.value);

  formData.append("InwardNo", `${parseInt(vndr?.InwardNo) + 1}`);
  formData.append("PurchaseDate", dateToSend);
  formData.append("ClientCode", clientCode);
  formData.append("CompanyId", CompanyId || 0);
  formData.append("CounterId", CounterId || 0);
  formData.append("BranchId", BranchId || 0);
  formData.append("EmployeeId", EmployeeId || 0);
  formData.append("TotalWtReceive", totalWtReceive);
  formData.append("TotalFineWithWstageWt", data?.TotalFineMetal);
  const skuid =
    data?.skus?.length && data?.skus[0]?.StockKeepingUnit
      ? data?.skus[0]?.StockKeepingUnit?.value
      : "";
  formData.append("StockKeepingUnit", skuid);
  formData.append("LotNumber", data?.LotNumber || "0");
  formData.append("TotalHallmarkAmount", totalHallmarkAmt);
  formData.append("TotalTagWeight", totalTagWeight);
  formData.append("TotalFindingWeight", totalFindingWeight);
  formData.append("TotalLanyardWeight", totalLanyardWeight);
  formData.append("UnlabelledSilverWeight", unlabelledSilverWeight);
  formData.append("UnlabelledGoldWeight", unlabelledGoldWeight);
  formData.append("UnlabelledOtherMetalWeight", unlabelledOtherMetalWeight);
  formData.append("TotalStoneWeight", totalStoneWeight);
  formData.append("TotalStoneAmount", totalStoneAmount);
  formData.append("TotalStonePieces", totalStonePieces);
  formData.append("TotalDiamondWeight", totalDiamondWeight);
  formData.append("TotalDiamondPieces", totalDiamondPieces);
  formData.append("TotalDiamondAmount", totalDiamondAmount);
  formData.append("TotalNetWt", data?.skus[0]?.CategoryId?.value == looseDiamondId ? 0 : totalNetWt);
  formData.append("TotalDiamondNetWt", data?.skus[0]?.CategoryId?.value == looseDiamondId ? totalDiamondNetWt : 0);
  formData.append("AssignedGoldWeight", "0");
  formData.append("AssignedSilverWeight", "0");
  formData.append("AssignedOtherMetalWeight", "0");
  formData.append("AssignedDiamondWeight", "0");

  return formData;
}

export function purchaseEntryJson({
  rcvdId,
  data,
  additionalInfo,
  vendorlist,
}) {
  const currentYear = new Date().getFullYear();
  console.log(data);
  const jsonData = data?.skus?.map((product) => {
    // return {
    //   ...item,
    //   LotNumber: "",
    //   MakingPercentage: `${product.MakingPercentage || 0}`,  // we dont have making percentage,
    //   Quantity: item?.Qty,
    //   PurityId: item?.PurityId?.value,
    //   CategoryId: item?.CategoryId?.value,
    //   ProductId: item?.ProductId?.value,
    //   DesignId: item?.DesignId?.value,
    //   FineGoldWt: "",
    //   FineSilverWt: "",
    //   FineOtherMetalWt: "",
    //   TotalStoneAmt: item?.StoneAmount,
    //   TotalItemAmt: item?.TotalItemAmount,
    //   RDPurchaseId: rcvdId,
    //   CategoryName: item?.CategoryId?.label,
    //   ProductName: item?.ProductId?.label,
    //   DesignName: item?.DesignId?.label,
    //   PurityName: item?.PurityId?.label,
    //   Status: "",
    //   CounterId:additionalInfo?.CounterId,
    //   BranchId:additionalInfo?.BranchId,
    //   CompanyId:additionalInfo?.CompanyId,
    //   FinePure: "",
    //   ClientCode: additionalInfo?.clientCode,
    //   StockKeepingUnit: item?.StockKeepingUnit?.value,
    //   ItemCode: "",
    //   AddToUnlabelled: item?.unlabeled,
    //   DiamondName: "",
    //   MetalId: "",
    //   StoneRate: "", // we have stone rate in StoneRateCt and StoneRatePc
    //   HallmarkAmt: item?.Hallmark,
    //   TagWeight: item?.TagWt,
    //   FindingWeight: item?.FindingWt,
    //   LanyardWeight: item?.LanyardWt,
    //   MRP: "",
    //   VendorId: data?.VendorName?.value,
    //   VendorName: data?.VendorName?.label,
    //   FirmName: "",
    //   SKUId: "",
    //   EmployeeId: additionalInfo?.employeeCode,
    //   ConvertAmount: "",
    //   UnlabelledSilverWeight: "",
    //   UnlabelledGoldWeight: "",
    //   UnlabelledOtherMetalWeight: "",
    //   AssignedGoldWeight: "",
    //   AssignedSilverWeight: "",
    //   AssignedOtherMetalWeight: "",
    //   AssignedDiamondWeight: "",
    //   TaxId: "",
    //   TaxPercentage: "",
    //   AvailableGrossWeight: "",
    //   AvailableNetWeight: "",
    //   AvailableStoneWeight: "",
    //   ClipWeight: item?.ClipWt,
    //   ClipQuantity: item?.ClipQty,
    //   DiamondPurchaseRate: "",
    //   DiamondSellRate: "",
    //   DiamondPurchaseAmount: "",
    //   DiamondSellAmount: "",
    //   MetalName: "",
    //   TotalDiamondQty: 0,
    //   TotalDiamondWeight: 0,
    //   TotalDiamondAmount: 0,
    //   TotalDiamondRate: 0,
    //   Stones: item?.Stones?.map((stone) => {
    //     return {
    //       ...stone,
    //       StoneRate: "",
    //       ClientCode: additionalInfo?.clientCode,
    //       RDPurchaseItemId: "",
    //       CompanyId: additionalInfo?.CompanyId,
    //       CounterId: additionalInfo?.CounterId,
    //       BranchId: additionalInfo?.BranchId,
    //       EmployeId: additionalInfo?.employeeCode,
    //     };
    //   }),
    //   Diamonds: item?.Diamonds?.map((diamond) => {
    //     return {
    //       ...diamond,
    //       Certificate: diamond?.DiamondCertificate,
    //       SettingType: diamond?.SettingType,
    //       DiamondPurchaseAmt: "",
    //       Description: diamond?.DiamondDescription,
    //       ClientCode:additionalInfo?.clientCode,
    //       PurchaseItemId: 0,
    //       CompanyId: additionalInfo?.CompanyId,
    //       CounterId: additionalInfo?.CounterId,
    //       BranchId: additionalInfo?.BranchId,
    //       EmployeId: additionalInfo?.employeeCode,
    //     };
    //   }),
    //   Payments: data?.paymentTypes?.map((payment) => {
    //     return {
    //       ...payment,
    //       CustomerId: 0,
    //       PaymentModeType: payment?.mode,
    //       PaymentSource: "",
    //       CreditDebit: "",
    //       Amount: payment?.amount,
    //       TransactionType: "",
    //       InvoiceNumber: data?.invoiceNumber,
    //       PaymentVisibility: "",
    //       FinancialYear: "2024",
    //       Branch: "Home",
    //       FineGold: "",
    //       FineSilver: "",
    //       FineOtherMetal: "",
    //       GoldRate: "0",
    //       SilverRate: "0",
    //       OtherMetalRate: "",
    //       GoldAmount: "",
    //       SilverAmount: "",
    //       OtherMetalAmount: "",
    //       OldGoldGrosswt: "",
    //       OldSilverGrosswt: "",
    //       OtherMetalGrossWt: "",
    //       GoldPurity: "",
    //       SilverPurity: "",
    //       OtherMetalPurity: "",
    //       VendorId: data?.VendorName?.value,
    //       InvoiceId: 0,
    //       InwardNo: "25",
    //       OrderId: 0,
    //       CustomerName: "",
    //       VendorName: data?.VendorName?.label,
    //       RDPurchaseId: 1067,
    //       Status: "Purchased",
    //       Description: payment?.description,
    //       ClientCode:additionalInfo?.clientCode,
    //       CompanyId: additionalInfo?.CompanyId,
    //       CounterId: additionalInfo?.CounterId,
    //       BranchId: additionalInfo?.BranchId,
    //       EmployeId: additionalInfo?.employeeCode,
    //     };
    //   }),
    // };

    const stoneDetails = product.Stones.map((stone) => ({
      StoneName: `${stone.StoneName || ""}`,
      StoneWeight: `${stone.StoneWeight}`,
      // StoneRate: `${stone.StoneRate}`,
      StoneRate: `${stone.StoneRateKarate}`, // we have dont have stone rate , we have rate in carate and rate in pieces, for we kept stoneratepercarat
      StonePieces: `${stone.StonePieces}`,
      StoneAmount: `${stone.StoneAmount || "0"}`,
      Description: `${stone.Description || ""}`,
    }));
    const diamondDetails = product.Diamonds.map((diamond) => ({
      // DiamondName: `${diamond.DiamondName}`,  // we have removed diamond name from the fields
      DiamondWeight: `${diamond.DiamondWeight || "0"}`,
      DiamondRate: `${diamond.DiamondRate || "0"}`,
      DiamondPieces: `${diamond.DiamondPieces}`,
      DiamondAmount: `${diamond.DiamondAmount || "0"}`,
      DiamondClarity: `${diamond.DiamondClarity}`,
      DiamondColour: `${diamond.DiamondColour}`,
      DiamondCut: `${diamond.DiamondCut}`,
      DiamondShape: `${diamond.DiamondShape}`,
      DiamondSize: `${diamond.DiamondSize}`,
      Certificate: `${diamond.DiamondCertificate}`,
      SettingType: `${diamond.DiamondSettingType}`,
      // DiamondPurchaseAmt: `${diamond.DiamondPurchaseAmt}`,
      DiamondPurchaseAmt: "", // we dont have diamond purchase amt
      Description: `${diamond.DiamondDescription}`,
    }));
    console.log(data?.paymentTypes);
    const Payments = data?.paymentTypes?.map((payment) => {
      return {
        // ...payment,
        // id:""+payment?.id,
        CustomerId: 0,
        PaymentModeType: payment?.mode,
        PaymentSource: "Purchase Bill",
        CreditDebit: "Debit",
        Amount: `${payment?.amount}`,
        // MetalCashTotalAmount:`${+(payment?.MetalCashTotalAmount || 0)}`,
        TransactionType: `${payment.status}`,
        InvoiceNumber: "" + data?.invoiceNumber,
        PaymentVisibility: "Active",
        FinancialYear: "" + currentYear,
        Branch: "Home",
        FineGold: goldCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? "" + payment.MetalFinePaid
          : "",
        FineSilver: silverCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? "" + payment.MetalFinePaid
          : "",
        FineOtherMetal: "",
        GoldRate: goldCategoryIds.includes(
          +(data.skus[0].CategoryId.value || 0)
        )
          ? "" + payment.MetalCashRatePerGram
          : "",
        SilverRate: silverCategoryIds.includes(
          +(data.skus[0].CategoryId.value || 0)
        )
          ? "" + payment.MetalCashRatePerGram
          : "",
        OtherMetalRate: "",
        GoldAmount: goldCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? `${+(payment?.MetalCashTotalAmount || 0)}`
          : "", // we dont have this
        SilverAmount: silverCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? `${+(payment?.MetalCashTotalAmount || 0)}`
          : "", // we dont have this
        OtherMetalAmount: "",
        OldGoldGrosswt: goldCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? "" + payment.MetalFinePaid
          : "",
        OldSilverGrosswt: silverCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? "" + payment.MetalFinePaid
          : "",
        OtherMetalGrossWt: "",
        GoldPurity: "",
        SilverPurity: "",
        OtherMetalPurity: "",
        VendorId: data?.VendorName?.value,
        InvoiceId: 0,
        InwardNo:
          vendorlist?.find((item) => data?.VendorName?.value == item?.Id)
            ?.InwardNo + 1,
        OrderId: 0,
        CustomerName: "",
        VendorName: data?.VendorName?.label,
        RDPurchaseId: rcvdId,
        Status: "Purchased",
        Description: payment?.description,
        ClientCode: additionalInfo?.clientCode,
        CompanyId: additionalInfo?.CompanyId,
        CounterId: additionalInfo?.CounterId,
        BranchId: additionalInfo?.BranchId,
        EmployeId: additionalInfo?.employeeCode,
        TCS: payment?.additionalTax || "",
      };
    });

    const totalStoneWeight = product.StoneWt;
    const totalStoneAmount = product.StoneAmount;
    const diamondPieces = product?.Diamonds?.reduce(
      (acc, diamond) => acc + parseFloat(diamond.DiamondPieces || 0),
      0
    );

    return {
      StockKeepingUnit:
        product.StockKeepingUnit?.value &&
        product.StockKeepingUnit?.value !== "undefined"
          ? `${product.StockKeepingUnit?.value}`
          : "",
      StockKeepingUnitName:
        product?.StockKeepingUnit?.label &&
        product?.StockKeepingUnit?.label !== "undefined"
          ? `${product.StockKeepingUnit?.label}`
          : "",
      ItemCode: product?.ItemCode || "", // what is item code
      MakingFixedAmt: `${product.MakingFixedAmt || 0}`,
      MakingPercentage: `${product.MakingPercentage || 0}`, // we dont have making percentage
      MakingPerGram: `${product.MakingPerGram || 0}`,
      MakingFixedWastage: `${product.MakingFixedWastage || 0}`,
      MetalRate: `${product.MetalRate || 0}`,
      FinePercent: `${product.FinePercent || 0}`,
      WastageWt: `${product.WastageWt || 0}`,
      WastagePercent: `${product.WastagePercent || 0}`,
      Quantity: `${product.Qty}`,
      Pieces: `${product?.Pieces}`,
      CategoryId: product?.CategoryId?.value
        ? parseInt(product?.CategoryId?.value)
        : 0,
      ProductId: product?.ProductId?.value
        ? parseInt(product?.ProductId?.value)
        : 0,
      PurchaseEntryNo: "",
      // FineGoldWt: product.ConvertAmount ? "0" : `${product.FineGold}`,
      FineGoldWt: "0", // we dont have
      // FineSilverWt: product.ConvertAmount ? "0" : `${product.FineSilver}`,
      FineSilverWt: "0", // we dont have
      // FineOtherMetalWt: `${product.FineOtherMetalWt}`,
      FineOtherMetalWt: "0", // we dont have
      TotalWeight: product?.TotalWt,
      PackingWeight: product?.PackingWeight || 0,
      TotalItemAmt: `${parseFloat(product?.TotalItemAmount || 0).toFixed(2)}`,
      FineWt: `${parseFloat(product?.FineWt || 0).toFixed(3)}`,
      // FinePure: product.FinePure,
      FinePure: false, // we dont have
      // ConvertAmount: product.ConvertAmount,
      ConvertAmount: false, // we dont have
      AddToUnlabelled: `${product.unlabeled}`,
      FineWastageWt: `${parseFloat(product?.FineWastageWt || 0).toFixed(3)}`,
      RDPurchaseId: parseInt(rcvdId),
      CategoryName: product?.CategoryId?.label,
      ProductName: product?.ProductId?.label,
      GrossWt: `${product?.GrossWt}`,
      NetWt: `${product?.NetWt}`,
      StoneWt: `${product?.StoneWt || product?.StoneWeight}`,
      Stones: stoneDetails,
      Diamonds: diamondDetails,
      Payments: Payments,
      StoneWeight: `${totalStoneWeight || 0}`,
      StonePieces: `${product?.StonePieces || 0}`,
      StoneAmount: `${totalStoneAmount || 0}`,
      MetalId: parseInt(product?.CategoryId?.value),
      HallmarkAmt: `${product?.Hallmark || 0}`,
      TagWeight: `${product?.TagWt || 0}`,
      FindingWeight: `${product?.FindingWt || 0}`,
      LanyardWeight: `${product?.LanyardWt || 0}`,
      PouchWeight: `${product?.PouchWeight || 0}`,
      UnlabelledGoldWeight:
        !product?.unlabeled &&
        product?.CategoryId?.label?.toLowerCase()?.includes("gold")
          ? `${product?.GrossWt}`
          : "0",

      UnlabelledOtherMetalWeight:
        !product.unlabeled &&
        !(
          product?.CategoryId?.label?.toLowerCase()?.includes("gold") &&
          !product?.CategoryId?.label?.toLowerCase()?.includes("silver")
        )
          ? `${product?.GrossWt}`
          : "0", // need to understand this properly have little confusion
      UnlabelledSilverWeight:
        !product?.unlabeled &&
        product?.CategoryId?.label?.toLowerCase()?.includes("silver")
          ? `${product?.GrossWt}`
          : "0",
      MRP: `0`,
      DesignId: product?.DesignId?.value
        ? parseInt(product?.DesignId?.value)
        : 0,
      DesignName: product?.DesignId?.label,
      PurityId: product?.PurityId?.value
        ? parseInt(product?.PurityId?.value)
        : 0,
      PurityName: product?.PurityId?.label,
      VendorName: data?.VendorName?.label,
      VendorId: `${data?.VendorName?.value}`, // Ensure selectedCustomer is defined
      SKUId: product?.SKUId ? product.SKUId : 0,
      ClipQuantity: `${product?.ClipQty}`,
      ClipWeight: `${product?.ClipWt}`,
      Testing: `${product?.Testing}`,
      ClientCode: additionalInfo?.clientCode,
      AssignedDiamondWeight: "0",
      AssignedGoldWeight: "0",
      AssignedOtherMetalWeight: "0",
      AssignedSilverWeight: "0",
      AvailableGrossWeight: !product?.unlabeled ? `${product?.GrossWt}` : "0",
      AvailableNetWeight: !product?.unlabeled ? `${product?.NetWt}` : "0",
      AvailableStoneWeight: !product?.unlabeled ? `${product?.StoneWt}` : "0",
      TotalDiamondWeight: `${parseFloat(product?.DiamondWeight || 0).toFixed(
        3
      )}`,
      // TotalDiamondQty: `${product.TotalDiamondQty}`, // we dont have diamond qty we have diamond pieces
      TotalDiamondQty: `${diamondPieces || product?.DiamondPieces || 0}`, // we dont have diamond qty we have diamond pieces
      TotalDiamondAmount: `${product.DiamondAmount}`,

      ///lose diamond and loose stone

      DiamondName: `${product?.DiamondName?.label || ""}`,
      DiamondNameId: product?.DiamondName?.value || 0,
      DiamondShapeId: product?.DiamondShape?.value || 0,
      DiamondShape: `${product?.DiamondShape?.label || ""}`,
      DiamondColourId: product?.DiamondColour?.value || 0,
      DiamondColour: `${product?.DiamondColour?.label || ""}`,
      DiamondClarityId: product?.DiamondClarity?.value || 0,
      DiamondClarity: `${product?.DiamondClarity?.label || ""}`,
      DiamondSleeve: `${product?.DiamondSleve?.label || ""}`,
      DiamondSleeveId: `${product?.DiamondSleve?.value || ""}`,
      DiamondSize: `${product?.DiamondSize?.label || ""}`,
      DiamondSizeId: `${product?.DiamondSize?.value || ""}`,
      DiamondSleeveGroup: `${product?.DiamondSleveGroup?.label || ""}`,
      DiamondSleeveGroupId: `${product?.DiamondSleveGroup?.value || ""}`,
      // DiamondWeight:`${product?.DiamondWeight}`,
      DiamondPieces:`${product?.DiamondPieces || ""}`,
      DiamondRate: `${product?.DiamondRate || ""}`,
      DiamondCutId: product?.DiamondCut?.value || 0,
      DiamondCut: `${product?.DiamondCut?.label || ""}`,
      DiamondSettingTypeId: product?.DiamondSettingType?.value || 0,
      DiamondSettingType: `${product?.DiamondSettingType?.label || ""}`,
      DiamondCertificate: `${product?.DiamondCertificate || ""}`,
      DiamondPacket: `${product?.DiamondPacket || ""}`,
      DiamondBox: `${product.DiamondBox || ""}`,
      DiamondDescription: `${product?.DiamondDescription || ""}`,

      StoneName: `${product?.StoneName}`,
      StoneShapeId: `${product?.StoneShape?.value}`,
      StoneShapeName: `${product?.StoneShape?.label}`,
      StoneColourId: `${product?.StoneColour?.value}`,
      StoneColourName: `${product?.StoneColour?.label}`,
      StoneSize: `${product?.StoneSize}`,
      StoneRateCt: `${product?.StoneRateCt}`,
      StoneRatePc: `${product?.StoneRatePc}`,
      StoneSettingTypeId: `${product?.StoneSettingType?.value}`,
      StoneSettingTypeName: `${product?.StoneSettingType?.label}`,
      StoneCertificate: `${product?.StoneCertificate}`,
      StonePacket: `${product?.StonePacket}`,
      Box: `${product.Box}`,
      StoneDescription: `${product?.StoneDescription}`,
    };
  });
  return jsonData;
}

export function purchaseEntryEditJSon({
  rcvdId,
  data,
  additionalInfo,
  vendorlist,
}) {
  const currentYear = new Date().getFullYear();
  const jsonData = data?.skus?.map((product) => {
    const stoneDetails = product.Stones.map((stone) => ({
      ...stone,
      StoneName: `${stone.StoneName}`,
      StoneWeight: `${stone.StoneWeight}`,
      // StoneRate: `${stone.StoneRate}`,
      StoneRate: `${stone.StoneRateKarate}`, // we have dont have stone rate , we have rate in carate and rate in pieces, for we kept stoneratepercarat
      StonePieces: `${stone.StonePieces}`,
      StoneAmount: `${stone.StoneAmount || "0"}`,
      Description: `${stone.Description || ""}`,
    }));
    const diamondDetails = product.Diamonds.map((diamond) => ({
      ...diamond,
      // DiamondName: `${diamond.DiamondName}`,  // we have removed diamond name from the fields
      DiamondWeight: `${diamond.DiamondWeight}`,
      DiamondRate: `${diamond.DiamondRate}`,
      DiamondPieces: `${diamond.DiamondPieces}`,
      DiamondAmount: `${diamond.DiamondAmount || "0"}`,
      DiamondClarity: `${diamond.DiamondClarity}`,
      DiamondColour: `${diamond.DiamondColour}`,
      DiamondCut: `${diamond.DiamondCut}`,
      DiamondShape: `${diamond.DiamondShape}`,
      DiamondSize: `${diamond.DiamondSize}`,
      Certificate: `${diamond.DiamondCertificate}`,
      SettingType: `${diamond.DiamondSettingType}`,
      // DiamondPurchaseAmt: `${diamond.DiamondPurchaseAmt}`,
      DiamondPurchaseAmt: "", // we dont have diamond purchase amt
      Description: `${diamond.DiamondDescription}`,
    }));
    const Payments = data?.paymentTypes?.map((payment) => {
      return {
        // ...payment,
        // id:""+payment?.id,
        ...payment,
        CustomerId: 0,
        PaymentModeType: payment?.mode,
        PaymentSource: "Purchase Bill",
        CreditDebit: "Debit",
        Amount: `${payment.amount}`,
        // MetalCashTotalAmount:`${+(payment?.MetalCashTotalAmount || 0)}`,
        TransactionType: `${payment.status}`,
        InvoiceNumber: "" + data?.invoiceNumber,
        PaymentVisibility: "Active",
        FinancialYear: "" + currentYear,
        Branch: "Home",
        FineGold: goldCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? "" + payment.MetalFinePaid
          : "",
        FineSilver: silverCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? "" + payment.MetalFinePaid
          : "",

        FineOtherMetal: "",
        GoldRate: goldCategoryIds.includes(
          +(data.skus[0].CategoryId.value || 0)
        )
          ? "" + payment.MetalCashRatePerGram
          : "",
        SilverRate: silverCategoryIds.includes(
          +(data.skus[0].CategoryId.value || 0)
        )
          ? "" + payment.MetalCashRatePerGram
          : "",
        OtherMetalRate: "",
        GoldAmount: goldCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? `${+(payment?.MetalCashTotalAmount || 0)}`
          : "", // we dont have this
        SilverAmount: silverCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? `${+(payment?.MetalCashTotalAmount || 0)}`
          : "", // we dont have this
        OtherMetalAmount: "",
        OldGoldGrosswt: goldCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? "" + payment.MetalFinePaid
          : "",
        OldSilverGrosswt: silverCategoryIds.includes(
          +(data.skus[0].CategoryId?.value || 0)
        )
          ? "" + payment.MetalFinePaid
          : "",
        OtherMetalGrossWt: "",
        GoldPurity: "",
        SilverPurity: "",
        OtherMetalPurity: "",
        VendorId: data?.VendorName?.value,
        InvoiceId: 0,
        InwardNo:
          vendorlist?.find((item) => data?.VendorName?.value == item?.Id)
            ?.InwardNo + 1,
        OrderId: 0,
        CustomerName: "",
        VendorName: data?.VendorName?.label,
        RDPurchaseId: rcvdId,
        Status: "Purchased",
        Description: payment?.description,
        ClientCode: additionalInfo?.clientCode,
        CompanyId: additionalInfo?.CompanyId,
        CounterId: additionalInfo?.CounterId,
        BranchId: additionalInfo?.BranchId,
        EmployeId: additionalInfo?.employeeCode,
      };
    });
    const totalStoneWeight = product.StoneWt;
    const totalStoneAmount = product.StoneAmount;
    const diamondPieces = product.Diamonds?.reduce(
      (acc, diamond) => acc + parseFloat(diamond.DiamondPieces || 0),
      0
    );

    return {
      ...product,
      StockKeepingUnit:
        product.StockKeepingUnit?.value &&
        product.StockKeepingUnit?.value !== "undefined"
          ? `${product.StockKeepingUnit?.value}`
          : "",
      StockKeepingUnitName:
        product?.StockKeepingUnit?.label &&
        product.StockKeepingUnit?.label !== "undefined"
          ? `${product.StockKeepingUnit?.label}`
          : "",
      ItemCode: product?.ItemCode || "", // what is item code
      MakingFixedAmt: `${product.MakingFixedAmt || 0}`,
      MakingPercentage: `${product.MakingPercentage || 0}`, // we dont have making percentage
      MakingPerGram: `${product.MakingPerGram || 0}`,
      MakingFixedWastage: `${product.MakingFixedWastage || 0}`,
      MetalRate: `${product.MetalRate || 0}`,
      FinePercent: `${product.FinePercent || 0}`,
      WastageWt: `${product.WastageWt || 0}`,
      WastagePercent: `${product.WastagePercent || 0}`,
      Quantity: `${product.Qty}`,
      CategoryId: product?.CategoryId?.value
        ? parseInt(product?.CategoryId?.value)
        : 0,
      ProductId: product?.ProductId?.value
        ? parseInt(product?.ProductId?.value)
        : 0,
      PurchaseEntryNo: "",
      // FineGoldWt: product.ConvertAmount ? "0" : `${product.FineGold}`,
      FineGoldWt: "0", // we dont have
      // FineSilverWt: product.ConvertAmount ? "0" : `${product.FineSilver}`,
      FineSilverWt: "0", // we dont have
      // FineOtherMetalWt: `${product.FineOtherMetalWt}`,
      FineOtherMetalWt: "0", // we dont have
      TotalWeight: product?.TotalWt,
      PackingWeight: product?.PackingWeight || 0,
      TotalItemAmt: `${parseFloat(product?.TotalItemAmount || 0).toFixed(2)}`,
      FineWt: `${parseFloat(product?.FineWt || 0).toFixed(3)}`,
      // FinePure: product.FinePure,
      FinePure: false, // we dont have
      // ConvertAmount: product.ConvertAmount,
      ConvertAmount: false, // we dont have
      AddToUnlabelled: `${product.unlabeled}`,
      FineWastageWt: `${parseFloat(product?.FineWastageWt || 0).toFixed(3)}`,
      RDPurchaseId: parseInt(rcvdId),
      CategoryName: product?.CategoryId?.label,
      ProductName: product?.ProductId?.label,
      GrossWt: `${product?.GrossWt}`,
      NetWt: `${product?.NetWt}`,
      StoneWt: `${product?.StoneWt}`,
      Stones: stoneDetails,
      Diamonds: diamondDetails,
      Payments: Payments,
      StoneWeight: `${totalStoneWeight || 0}`,
      StonePieces: `${product?.StonePieces || 0}`,
      StoneAmount: `${totalStoneAmount || 0}`,
      MetalId: parseInt(product?.CategoryId?.value),
      HallmarkAmt: `${product?.Hallmark || 0}`,
      TagWeight: `${product?.TagWt || 0}`,
      FindingWeight: `${product?.FindingWt || 0}`,
      LanyardWeight: `${product?.LanyardWt || 0}`,
      UnlabelledGoldWeight:
        !product?.unlabeled &&
        product?.CategoryId?.label?.toLowerCase()?.includes("gold")
          ? `${product?.GrossWt}`
          : "0",
      UnlabelledOtherMetalWeight:
        !product.unlabeled &&
        !(
          product?.CategoryId?.label?.toLowerCase()?.includes("gold") &&
          !product?.CategoryId?.label?.toLowerCase()?.includes("silver")
        )
          ? `${product?.GrossWt}`
          : "0", // need to understand this properly have little confusion
      UnlabelledSilverWeight:
        !product?.unlabeled &&
        product?.CategoryId?.label?.toLowerCase()?.includes("silver")
          ? `${product?.GrossWt}`
          : "0",
      MRP: `0`,
      DesignId: product?.DesignId?.value
        ? parseInt(product?.DesignId?.value)
        : 0,
      DesignName: product?.DesignId?.label,
      PurityId: product?.PurityId?.value
        ? parseInt(product?.PurityId?.value)
        : 0,
      PurityName: product?.PurityId?.label,
      VendorName: data?.VendorName?.label,
      VendorId: `${data?.VendorName?.value}`, // Ensure selectedCustomer is defined
      SKUId: product?.SKUId ? product.SKUId : 0,
      ClipQuantity: `${product?.ClipQty}`,
      ClipWeight: `${product?.ClipWt}`,
      Testing: `${product?.Testing}`,
      ClientCode: additionalInfo?.clientCode,
      AssignedDiamondWeight: "0",
      AssignedGoldWeight: "0",
      AssignedOtherMetalWeight: "0",
      AssignedSilverWeight: "0",
      AvailableGrossWeight: !product?.unlabeled ? `${product?.GrossWt}` : "0",
      AvailableNetWeight: !product?.unlabeled ? `${product?.NetWt}` : "0",
      AvailableStoneWeight: !product?.unlabeled ? `${product?.StoneWt}` : "0",
      TotalDiamondWeight: `${parseFloat(product?.DiamondWeight || 0).toFixed(
        3
      )}`,
      // TotalDiamondQty: `${product.TotalDiamondQty}`, // we dont have diamond qty we have diamond pieces
      TotalDiamondQty: `${diamondPieces}`, // we dont have diamond qty we have diamond pieces
      TotalDiamondAmount: `${product.DiamondAmount}`,

      ///lose diamond and loose stone

      DiamondShapeId: `${product?.DiamondShape?.value}`,
      DiamondShapeName: `${product?.DiamondShape?.label}`,
      DiamondColourId: `${product?.DiamondColour?.value}`,
      DiamondColourName: `${product?.DiamondColour?.label}`,
      DiamondClarityId: `${product?.DiamondClarity?.value}`,
      DiamondClarityName: `${product?.DiamondClarity?.label}`,
      DiamondSleeve: `${product?.DiamondSleve}`,
      DiamondSize: `${product?.DiamondSize}`,
      DiamondRate: `${product?.DiamondRate}`,
      DiamondCutId: `${product?.DiamondCut?.value}`,
      DiamondCutName: `${product?.DiamondCut?.label}`,
      DiamondSettingTypeId: `${product?.DiamondSettingType?.value}`,
      DiamondSettingTypeName: `${product?.DiamondSettingType?.label}`,
      DiamondCertificate: `${product?.DiamondCertificate}`,
      DiamondPacket: `${product?.DiamondPacket}`,
      DiamondBox: `${product.DiamondBox}`,
      DiamondDescription: `${product?.DiamondDescription}`,

      StoneName: `${product?.StoneName}`,
      StoneShapeId: `${product?.StoneShape?.value}`,
      StoneShapeName: `${product?.StoneShape?.label}`,
      StoneColourId: `${product?.StoneColour?.value}`,
      StoneColourName: `${product?.StoneColour?.label}`,
      StoneSize: `${product?.StoneSize}`,
      StoneRateCt: `${product?.StoneRateCt}`,
      StoneRatePc: `${product?.StoneRatePc}`,
      StoneSettingTypeId: `${product?.StoneSettingType?.value}`,
      StoneSettingTypeName: `${product?.StoneSettingType?.label}`,
      StoneCertificate: `${product?.StoneCertificate}`,
      StonePacket: `${product?.StonePacket}`,
      Box: `${product.Box}`,
      StoneDescription: `${product?.StoneDescription}`,
    };
  });

  return jsonData;
}

export const looseStoneId = 12;
export const looseDiamondId = 8;
export const oldGoldId = 6;
export const oldSilverId = 7;

// export function

export const selectStyle = {
  control: (base) => ({
    ...base,
    minHeight: "35px", // Decreases the height of the input
    height: "30px", // Ensures the height is consistent
    minWidth: '148px'
  
  }),
  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "14px", // Adjusts the font size of the selected value
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

export function getPurchaseDataToGenerateId() {
  const obj = {};
}

export const convertIntoFormData = (data, purchaseItems) => {
  return {
    ...data,
    StockKeepingUnit: "",
    LotNumber: data?.LotNumber,
    ItemCode: "",
    MakingFixedAmt: 0,
    MakingPerGram: 0,
    MakingFixedWastage: 0,
    MakingPercentage: 0,
    MetalRate: 0,
    FinePercent: 0,
    WastagePercent: 0,
    Quantity: 1,
    PurityId: 0,
    CategoryId: 0,
    ProductId: 0,
    DesignId: 0,
    FineGoldWt: 0,
    FineSilverWt: 0,
    TotalFineGold: "-9.2",
    FineOtherMetalWt: 0,
    TotalStoneAmt: 0,
    TotalItemAmt: 0,
    FineWt: 0,
    WastageWt: 0,
    FineWastageWt: 0,
    RDPurchaseId: 0,
    CategoryName: "",
    ProductName: "",
    DesignName: "",
    GrossWt: 0,
    NetWt: 0,
    StoneWt: 0,
    Status: "Active",
    CounterId: 0,
    BranchId: 0,
    CompanyId: 0,
    FinePure: false,
    ClientCode: 0,
    AddToUnlabelled: false,
    MetalId: 0,
    MetalName: "",
    StoneName: "",
    StoneWeight: 0,
    StonePieces: 0,
    StoneRate: 0,
    StoneAmount: 0,
    HallmarkAmt: 0,
    TagWeight: 0,
    FindingWeight: 0,
    LanyardWeight: 0,
    Testing: "0",
    Stones: [],
    Diamonds: [],
    ConvertAmount: true,
    MRP: "0",
    ClipWeight: "0",
    ClipQuantity: "0",
    DiamondName: "",
    DiamondWeight: 0,
    DiamondRate: 0,
    DiamondPieces: 0,
    DiamondAmount: 0,
    DiamondSize: "0",
    DiamondPurchaseRate: "0",
    DiamondSellRate: "0",
    DiamondClarity: "",
    DiamondColour: "",
    DiamondShape: "",
    DiamondCut: "",
    DiamondSettingType: "",
    DiamondCertificate: "",
    DiamondPurchaseAmount: "0",
    DiamondSellAmount: "0",
    DiamondDescription: "",
    status: "",
    skus: purchaseItems?.map((item) => {
      return {
        ...item,

        unlabeled:
          item?.AddToUnlabelled == "true"
            ? true
            : item?.AddToUnlabelled == "false"
            ? false
            : false,
        ClipQty: "" + item?.ClipQuantity,
        ClipWt: "" + item?.ClipWeight,
        FindingWt: "" + item?.FindingWeight,
        PackingWeight: "" + item?.PackingWeight,
        TotalWt: "" + item?.TotalWeight,
        GrossWt: "" + (item?.GrossWt || 0),
        Hallmark: "" + (item?.HallmarkAmt || 0),
        LanyardWt: "" + (item?.LanyardWeight || 0),
        LotNumber: item?.LotNumber,
        Qty: "" + (item?.Quantity || 0),
        StoneRateKarate: "" + (item?.StoneRate || 0),
        TagWt: "" + (item?.TagWeight || 0),
        DiamondAmount: "" + (item?.TotalDiamondAmount || 0),
        diamondPieces: "" + (item?.TotalDiamondQty || 0),
        DiamondWeight: "" + (item?.TotalDiamondWeight || 0),
        TotalItemAmount: "" + (item?.TotalItemAmt || 0),

        StockKeepingUnit: {
          value:
            item?.StockKeepingUnit !== "undefined" && item?.StockKeepingUnit
              ? "" + item?.StockKeepingUnit
              : "",
          label:
            item?.StockKeepingUnitName !== "undefined" &&
            item?.StockKeepingUnitName
              ? "" + item?.StockKeepingUnitName
              : "",
        },
        Diamonds: item?.Diamonds?.length
          ? item.Diamonds?.map((diamond) => {
              return {
                ...diamond,
                DiamondCertificate: diamond?.Certificate,
                DiamondDescription: diamond?.Description,
                DiamondAmount: diamond?.DiamondAmount,
                DiamondSettingType: diamond?.SettingType,
              };
            })
          : [],
        Stones: item?.Stones?.length
          ? item.Stones?.map((stone) => {
              return {
                ...stone,
                StoneRateKarate: stone?.StoneRate,
              };
            })
          : [],

        CategoryId: {
          value: "" + item?.CategoryId,
          label: item?.CategoryName,
        },
        ProductId: {
          value: "" + item?.ProductId,
          label: item?.ProductName,
        },
        DesignId: {
          value: "" + item?.DesignId,
          label: item?.DesignName,
        },
        PurityId: {
          value: "" + item?.PurityId,
          label: item?.PurityName,
        },

        // loose diamond and loose stone
        StoneSettingType: {
          value: "" + item?.StoneSettingTypeId,
          label: item?.StoneSettingTypeName,
        },
        DiamondSettingType: {
          value: "" + item?.DiamondSettingTypeId,
          label: item?.DiamondSettingType,
        },
        StoneCertificate: item?.StoneCertificate,
        DiamondCertificate: item?.DiamondCertificate,
        StonePacket: item?.StonePacket,
        DiamondPacket: item?.DiamondPacket,
        DiamondBox: item?.DiamondBox,
        Box: item?.Box,
        StoneDescription: item?.StoneDescription,
        DiamondDescription: item?.DiamondDescription,

        DiamondShape: {
          value: "" + item?.DiamondShapeId,
          label: item?.DiamondShape,
        },
        DiamondColour: {
          value: "" + item?.DiamondColourId,
          label: item?.DiamondColour,
        },
        DiamondClarity: {
          value: "" + item?.DiamondClarityId,
          label: item?.DiamondClarity,
        },
        DiamondSleeve: {value:""+item?.DiamondSleeveId,label:item?.DiamondSleeve},
        DiamondSize: {value:""+item?.DiamondSizeId,label:item?.DiamondSize},
        DiamondRate: "" + item?.DiamondRate,
        DiamondCut: {
          value: "" + item?.DiamondCutId,
          label: item?.DiamondCut,
        },
        StoneName: item?.StoneName,
        StoneShape: {
          value: "" + item?.StoneShapeId,
          label: item?.StoneShapeName,
        },
        StoneColour: {
          value: "" + item?.StoneColourId,
          label: item?.StoneColourName,
        },
        StoneSize: "" + item?.StoneSize,
        StoneRateCt: "" + item?.StoneRateCt,
        StoneRatePc: "" + item?.StoneRatePc,
      };
    }),

    paymentTypes: data?.Payments?.length
      ? data?.Payments?.map((payment) => {
          return {
            ...payment,
            mode: payment?.PaymentModeType,
            amount: payment?.Amount,
            status: payment?.TransactionType,
            invoiceNumber: payment?.InvoiceNumber,
            MetalFinePaid: payment?.FineGold || payment?.FineSilver,
            MetalCashRatePerGram: payment?.GoldRate || payment?.SilverRate,
            MetalFinePaid: payment?.FineGold || payment?.FineSilver,
            VendorName: {
              value: payment?.VendorId,
              label: payment?.VendorName,
            },
            description: payment?.Description,
            MetalCashTotalAmount: payment?.GoldAmount || payment?.SilverAmount,
          };
        })
      : [],

    balanceGold: data?.BalanceGold,
    taxableAmount: "",
    gst: "",
    paidAmount: "",
    balanceSilver: "",
    RODiscount: "",
    totalAmount: "",
    balanceAmount: "",
    invoiceDate: data?.PurchaseDate,
    invoiceNumber: data?.InvoiceNo,
    TotalFineSilver: "0",
    advanceamount: "0",
    balanceamount: "0",
    TotalFineMetal: data?.TotalFineGold || data?.TotalFineSilver, //
    TotalPaidMetal: "0.000", // not available
    TotalBalanceMetal: data?.BalanceGold || data?.BalanceSilver, //  not available
    TotalAdvanceAmount: "0.000", // not available
    TotalPaidAmount: "0.000", // not available
    TotalTaxableAmount: data?.TotalNetAmount || "0.000",
    gstCheckbox: data?.GSTApplied == "true" ? true : false,
    TotalGst: data?.TotalGSTAmount || "0.000",
    TotalRODiscount: data?.Discount || "0.000",
    TotalBillAmount: data?.TotalPurchaseAmount || "0.000",
    TotalBalanceAmount: data?.BalanceAmount || "0.000",
    VendorName: {
      value: data?.VendorId,
      label: data?.VendorName,
    },
  };
};

export function getTodaysDateFormat() {
  const today = new Date();
  const year = today.getFullYear();
  // Pad the month and day with a leading zero if they are less than 10
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getInvoiceEntryFormData({
  data,
  customerList,
  clientCode,
  invoiceDate,
  CompanyId,
  CounterId,
  BranchId,
  EmployeeId,
  employeeFirstName,
  employeeLastName,
}) {
  console.log(data);
  const paymentsString = data?.paymentTypes
    ?.map((payment) => `${payment.status}:${payment.amount}`)
    .join(",");
  const urdPurchaseAmt = 0; // not available in our system
  const totalPaidAmount = data?.paymentTypes.reduce(
    (total, payment) =>
      total +
      (payment.status !== "received" ? parseFloat(payment?.amount || 0) : 0),
    0
  );
  const allProdctsNetAmount = data?.skus?.reduce(
    (total, product) => total + +(product?.FinalPrice || 0),
    0
  );
  const grandTotal = +(data?.TotalTaxableAmount || 0) + +(data?.TotalGst || 0);
  const totalGrossWt = data?.skus?.reduce(
    (total, product) => total + +(product?.GrossWt || 0),
    0
  );
  const totalNetWt = data?.skus?.reduce(
    (total, product) => total + +(product?.NetWt || 0),
    0
  );
  const totalQuantity = data?.skus?.reduce(
    (a, b) => a + +(b?.Qty || b?.Pieces || 0),
    0
  );
  const totalStoneWt = data?.skus?.reduce((a, b) => a + +(b?.StoneWt || 0), 0);

  const orderItemsList = data?.skus?.map((product) => {
    return {
      Amount: (+(product?.Amount || 0))?.toFixed(2),
      BillType: product?.OldGoldPurchase ? "purchase" : "sale",
      SKUId: product?.SKUId ? `${product?.SKUId}` : "0", // need to add
      SKU: product?.SKU ? `${product?.SKU}` : "", // need to add
      CategoryName: product.CategoryName ? `${product.CategoryName}` : "",
      CategoryId: product.CategoryId ? `${product.CategoryId}` : "", // need to add
      ProductId: product.ProductId ? `${product.ProductId}` : "",
      ProductName: product?.ProductName ? `${product?.ProductName}` : "",
      PurityId: product?.PurityId ? `${+(product?.PurityId || 0)}` : "0",
      Purity: product?.PurityName ? `${product?.PurityName}` : "",
      DesignId: product?.DesignId ? `${+(product?.DesignId || 0)}` : "0", // need to add
      DesignName: product?.DesignName ? `${product?.DesignName}` : "", // need to add
      TotalWt: product?.TotalWeight ? `${product?.TotalWeight}` : "",
      PackingWeight: product?.PackingWeight ? `${product?.PackingWeight}` : "",
      GrossWt: product?.GrossWt ? `${product?.GrossWt}` : "",
      TotalStoneWeight: product?.TotalStoneWeight
        ? `${product?.TotalStoneWeight}`
        : "",
      DiamondWeight: product?.DiamondWeight ? `${product?.DiamondWeight}` : "",
      NetWt: product?.NetWt ? `${product?.NetWt}` : "",
      MetalRate: product?.MetalRate ? `${product?.MetalRate}` : "", // little confusion is gold rate metal rate same ?
      Quantity: `${product?.Qty || 0}`,
      Pieces: `${product?.Pieces || 0}`,
      FinePercentage: product?.FinePercent ? `${product?.FinePercent}` : "",
      MakingPercentage: product?.MakingPercentage
        ? `${product?.MakingPercentage}`
        : "",
      MakingPerGram: product?.MakingPerGram ? `${product?.MakingPerGram}` : "",
      MakingFixedAmt: product?.MakingFixedAmt,
      MakingFixedWastage: product?.MakingFixedWastage,
      TotalStonePieces: product?.StonePieces, // need to add
      StonePieces: product?.StonePieces, // need to add Amount
      StoneAmount: `${product?.StoneAmount || product?.TotalStoneAmount}`,
      TotalStoneAmount: `${product?.StoneAmount || product?.TotalStoneAmount}`, // we dont have this
      HallmarkAmount: product?.HallmarkAmount,
      MetalAmount: `${product?.MetalAmount || 0}`,
      FineWt: product?.FineWt, // need to add
      WastageWt: product?.WastageWt,
      FineWastageWt: `${+(product?.FineWastageWt || 0)}`, // need to add
      CuttingGrossWt: product?.CuttingGrossWt,
      CuttingNetWt: product?.CuttingNetWt,
      MRP: `${product?.MRP}`,
      TotalItemAmount: `${product?.TotalItemAmount || 0}`,

      CustomerId: parseInt(data?.customerName?.value || 0),

      HSNCode: `${product?.HSNCode || ""}`,

      MakingCharg: product?.MakingCharg || "",
      ProductCode: "",
      ProductNo: "",
      NetAmount: product?.NetAmount,
      GSTAmount: product?.GSTAmount,
      totalGstAmount: product?.totalGstAmount,
      TotalAmount: product?.TotalAmount,
      finalPrice: product?.finalPrice,
      ConvertAmt: product?.ConvertAmt,
      MakingCharg: product?.Making ? `${product?.Making}` : "0",
      HUIDCode: product?.HUIDCode || "", // we don't have this
      Size: product?.Size || "", // we don't have this
      OnlineStatus: "Billed",
      Price: `${(
        parseFloat(product?.FinalPrice || 0) +
        parseFloat(product?.TotalGST || 0)
      ).toFixed(3)}`,
      LabelledStockId: `${product?.Id || 0}` || "", // Ensure LabelledStockId is present
      UnlProductId: `${+(product?.Id || "")}` || "",
      Stones:
        product?.Stones && product?.Stones?.length > 0 ? product.Stones : [], // Ensure Stones array
      Diamonds:
        product?.Diamonds && product?.Diamonds?.length > 0
          ? product.Diamonds
          : [],
      ItemCode: product?.ItemCode || "",
      Status: "Sold",
      Images:product?.Images
      
    };
  });
  const currentYear = new Date().getFullYear();

  const paymentsList = data?.paymentTypes?.map((payment) => {
    return {
      ClientCode: clientCode,
      PaymentSource: "Sale Bill",
      Description: payment?.description,
      PaymentModeType: `${payment?.mode}`,
      CreditDebit: "Credit",
      Amount: `${payment?.amount}`,
      TransactionType: `${payment.status}`,
      // TransactionType: "Receive",
      VendorId: 0,
      InvoiceNumber: data?.invoiceNumber,
      CustomerId: parseInt(data?.customerName?.value || ""),
      BillType: "sale",
      PaymentVisibility: "Active",
      FinancialYear: `${currentYear}`,
      Branch: "Home",
      CompanyId: CompanyId ? CompanyId : 0,
      CounterId: CounterId ? CounterId : 0,
      BranchId: BranchId ? BranchId : 0,
      EmployeId: EmployeeId ? EmployeeId : 0,
      // FineGold: ""+payment.MetalFinePaid,
      // FineSilver: ""+payment.MetalFinePaid,
      // GoldRate: ""+payment.MetalCashRatePerGram,
      // SilverRate: ""+payment.MetalCashRatePerGram,
      // OldGoldGrosswt: ""+payment.MetalFinePaid,
      // OldSilverGrosswt: ""+payment.MetalFinePaid,
      // SilverAmount: `${payment.goldAmount}`,
      // GoldAmount: `${payment.silverAmount}`,
      MetalType: payment?.MetalType,
      FineGold: goldCategoryIds.includes(+(data.skus[0]?.SKUId || 0))
        ? "" + payment.MetalFinePaid
        : "",

      FineSilver: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalFinePaid
        : "",
      FineOtherMetal: "",
      GoldRate: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalCashRatePerGram
        : "",
      SilverRate: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalCashRatePerGram
        : "",
      OtherMetalRate: "",
      GoldAmount: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? `${+(payment?.MetalCashTotalAmount || 0)}`
        : "",
      SilverAmount: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? `${+(payment?.MetalCashTotalAmount || 0)}`
        : "",
      OtherMetalAmount: "",
      OldGoldGrosswt: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalFinePaid
        : "",
      OldSilverGrosswt: silverCategoryIds.includes(
        +(data.skus[0].CategoryId || 0)
      )
        ? "" + payment.MetalFinePaid
        : "",
      OtherMetalGrossWt: "0",
      GoldPurity: "",
      SilverPurity: "",
      OtherMetalPurity: "",
      PurchaseOrderId: 0,
      OrderId: 0,
      InvoiceId: 0,
      // OrderId: data?.invoiceNumber,
      // InvoiceId: data?.invoiceNumber,
      RDPurchaseId: 0,
      CustomerName: `${data?.customerName?.label}`,
      VendorName: "",
      InwardNo: "0",
      Status: "Sold",
      TDS: "0",
    };
  });

  const formData = {
    ClientCode: clientCode,
    CustomerId: `${data?.customerName?.value}` || "",
    Billedby: `${
      data?.selectedCashierEmployee ||
      `${employeeFirstName} ${employeeLastName}`
    }`,
    SaleType: "Sale",
    Soldby: `${data?.selectedSalesEmployee || employeeFirstName}`,
    PaymentMode: `${paymentsString}`,
    UrdPurchaseAmt: `${(+(urdPurchaseAmt || 0))?.toFixed(3)}`, // we dont have this
    GST: `${(+(data?.TotalGst || 0))?.toFixed(3)}`,
    TDS: `${+(data?.additionalTax || 0)}`,
    ReceivedAmount: (+(data?.TotalPaidAmount || 0))?.toFixed(2),
    InvoiceStatus:
      data?.wholesaleProductList?.length > 0 ? "Invoice Created" : "Delivered", // from where we will get this wholesaleProductList
    Visibility: data?.gstCheckboxConfirm ? "Visible" : "Hidden",

    Offer: `${data?.TotalRODiscount || 0}`,
    CourierCharge: `${+(data?.CourierCharge || 0)}`,
    TotalAmount: `${(+(data?.TotalTaxableAmount || 0))?.toFixed(3)}`,
    BillType: `${data?.gstCheckboxConfirm}`,
    InvoiceDate: `${data?.invoiceDate || getTodaysDateFormat()}`,
    InvoiceNo: data?.invoiceNumber,
    BalanceAmt: `${+(grandTotal || 0)}`,
    CreditAmount: "0",
    CreditGold: "0",
    CreditSilver: "0",
    GrossWt: `${totalGrossWt}`,
    NetWt: `${totalNetWt}`,
    StoneWt: `${totalStoneWt.toFixed(3)}`,
    Qty: `${totalQuantity}`,

    TotalDiamondAmount: "0",
    TotalDiamondPieces: "0",
    TotalDiamondWeight: "0",
    TotalSaleGold: "0",
    TotalSaleSilver: "0",
    TotalSaleUrdGold: "0",
    TotalSaleUrdSilver: "0",
    TotalStoneAmount: "0",
    TotalStonePieces: "0",
    TotalStoneWeight: "0",

    BalanceGold: "0",
    BalanceSilver: "0",
    OrderType: "Tax Invoice", // not clear what to do
    // pendingApproval
    //  ? "Pending Approval"
    //  : !pendingApproval && !applyGstAmount
    //    ? "Estimate"
    //    : "Tax Invoice",

    InvoiceItem: orderItemsList,
    Payments: paymentsList,

    TotalNetAmount: parseFloat(data?.TotalTaxableAmount || 0).toFixed(3),
    TotalFineMetal: parseFloat(data?.TotalFineMetal || 0).toFixed(3), //
    TotalBalanceMetal: parseFloat(data?.TotalBalanceMetal || 0).toFixed(3), //  not available
    GSTApplied: data?.gstCheckbox ? "true" : "false",
    gstCheckboxConfirm: data?.gstCheckboxConfirm ? "true" : "false",
    AdditionTaxApplied: data?.additionalTaxCheckbox ? "true" : "false",
    TotalGSTAmount: parseFloat(data?.TotalGst || 0).toFixed(3),
    Discount: parseFloat(data?.TotalRODiscount || 0).toFixed(3),
    TotalPurchaseAmount: parseFloat(data?.TotalBillAmount || 0).toFixed(3),
    BalanceAmount: parseFloat(data?.TotalBalanceAmount || 0).toFixed(3),
  };

  return formData;
}



export function getInvoiceEditEntryFormData({
  data,
  customerList,
  clientCode,
  invoiceDate,
  CompanyId,
  CounterId,
  BranchId,
  EmployeeId,
  employeeFirstName,
  employeeLastName,
}) {
  console.log(data);
  const paymentsString = data?.paymentTypes
    ?.map((payment) => `${payment.status}:${payment.amount}`)
    .join(",");
  const urdPurchaseAmt = 0; // not available in our system
  const totalPaidAmount = data?.paymentTypes.reduce(
    (total, payment) =>
      total +
      (payment.status !== "received" ? parseFloat(payment?.amount || 0) : 0),
    0
  );
  const allProdctsNetAmount = data?.skus?.reduce(
    (total, product) => total + +(product?.FinalPrice || 0),
    0
  );
  const grandTotal = +(data?.TotalTaxableAmount || 0) + +(data?.TotalGst || 0);
  const totalGrossWt = data?.skus?.reduce(
    (total, product) => total + +(product?.GrossWt || 0),
    0
  );
  const totalNetWt = data?.skus?.reduce(
    (total, product) => total + +(product?.NetWt || 0),
    0
  );
  const totalQuantity = data?.skus?.reduce(
    (a, b) => a + +(b?.Qty || b?.Pieces || 0),
    0
  );
  const totalStoneWt = data?.skus?.reduce((a, b) => a + +(b?.StoneWt || 0), 0);

  const orderItemsList = data?.skus?.map((product) => {
    let item = {
      ...product,

      BillType: "sale",
      SKUId: product?.SKUId ? `${product?.SKUId}` : 0, // need to add
      SKU: product?.SKU ? `${product?.SKU}` : "", // need to add
      CategoryName: product.CategoryName ? `${product.CategoryName}` : "",
      CategoryId: product.CategoryId ? `${product.CategoryId}` : "", // need to add
      ProductId: product.ProductId ? `${product.ProductId}` : "",
      ProductName: product?.ProductName ? `${product?.ProductName}` : "",
      PurityId: product?.PurityId ? `${product?.PurityId}` : 0,
      Purity: product?.PurityName ? `${product?.PurityName}` : "",
      DesignId: product?.DesignId ? `${product?.DesignId}` : 0, // need to add
      DesignName: product?.DesignName ? `${product?.DesignName}` : "", // need to add
      TotalWt: product?.TotalWeight ? `${product?.TotalWeight}` : "",
      PackingWeight: product?.PackingWeight ? `${product?.PackingWeight}` : "",
      GrossWt: product?.GrossWt ? `${product?.GrossWt}` : "",
      TotalStoneWeight: product?.TotalStoneWeight
        ? `${product?.TotalStoneWeight}`
        : "",
      DiamondWeight: product?.DiamondWeight ? `${product?.DiamondWeight}` : "",
      NetWt: product?.NetWt ? `${product?.NetWt}` : "",
      MetalRate: product?.MetalRate ? `${product?.MetalRate}` : "", // little confusion is gold rate metal rate same ?
      Quantity: `${product?.Qty || 0}`,
      FinePercentage: product?.FinePercent ? `${product?.FinePercent}` : "",
      MakingPercentage: product?.MakingPercentage
        ? `${product?.MakingPercentage}`
        : "",
      MakingPerGram: product?.MakingPerGram ? `${product?.MakingPerGram}` : "",
      MakingFixedAmt: product?.MakingFixedAmt,
      MakingFixedWastage: product?.MakingFixedWastage,
      TotalStonePieces: product?.TotalStonePieces, // need to add
      StoneAmount: `${product?.StoneAmount || product?.TotalStoneAmount}`,
      TotalStoneAmount: `${product?.TotalStoneAmount || 0}`, // we dont have this
      HallmarkAmount: product?.HallmarkAmount,
      MetalAmount: `${product?.MetalAmount || 0}`,
      FineWt: product?.FineWt, // need to add
      WastageWt: product?.WastageWt,
      FineWastageWt: `${+(product?.FineWastageWt || 0)}`, // need to add
      CuttingGrossWt: product?.CuttingGrossWt,
      CuttingNetWt: product?.CuttingNetWt,
      MRP: `${product?.MRP}`,
      TotalItemAmount: `${product?.TotalItemAmount || 0}`,

      CustomerId: parseInt(data?.customerName?.value || 0),

      HSNCode: `${product?.HSNCode || ""}`,

      MakingCharg: product?.MakingCharg || "",
      ProductCode: "",
      ProductNo: "",
      NetAmount: product?.NetAmount,
      GSTAmount: product?.GSTAmount,
      totalGstAmount: product?.totalGstAmount,
      TotalAmount: product?.TotalAmount,

      finalPrice: product?.finalPrice,
      ConvertAmt: product?.ConvertAmt,

      MakingCharg: product?.Making ? `${product?.Making}` : "0",

      HUIDCode: product?.HUIDCode || "", // we don't have this
      Size: product?.Size || "", // we don't have this

      OnlineStatus: "Billed",
      Price: `${(
        parseFloat(product?.FinalPrice || 0) +
        parseFloat(product?.TotalGST || 0)
      ).toFixed(3)}`,
      LabelledStockId:
        `${
          +(product?.Id || "")
            ? +(product?.Id || "")
            : +(product?.LabelledStockId || "")
            ? +(product?.LabelledStockId || "")
            : ""
        }` || 0,
      UnlProductId:
        `${
          +(product?.Id || "")
            ? +(product?.Id || "")
            : +(product?.LabelledStockId || "")
            ? +(product?.LabelledStockId || "")
            : ""
        }` || 0,
      // LabelledStockId: product?.sell ? product.Id : 0, // Ensure LabelledStockId is present
      Stones:
        product?.Stones && product?.Stones?.length > 0 ? product.Stones : [], // Ensure Stones array
      Diamonds:
        product?.Diamonds && product?.Diamonds?.length > 0
          ? product.Diamonds
          : [],
      ItemCode: product?.ItemCode || "",
    };

    return item;
  });
  const currentYear = new Date().getFullYear();

  const paymentsList = data?.paymentTypes?.map((payment) => {
    return {
      ...payment,
      ClientCode: clientCode,
      PaymentSource: "Sale Bill",
      Description: payment?.description,
      PaymentModeType: `${payment?.mode}`,
      CreditDebit: "Credit",
      Amount: `${payment?.amount}`,
      amount: (+(payment?.amount || 0))?.toFixed(3),
      TransactionType: `${payment.status}`,
      // TransactionType: `${payment.paymentType}`,
      // TransactionType: "Receive",
      VendorId: 0,
      InvoiceNumber: data?.invoiceNumber,
      CustomerId: parseInt(data?.customerName?.value || ""),
      BillType: "sale",
      PaymentVisibility: "Active",
      FinancialYear: `${currentYear}`,
      Branch: "Home",
      CompanyId: CompanyId ? CompanyId : 0,
      CounterId: CounterId ? CounterId : 0,
      BranchId: BranchId ? BranchId : 0,
      EmployeId: EmployeeId ? EmployeeId : 0,
      // FineGold: "" + payment.MetalFinePaid,
      // FineSilver: "" + payment.MetalFinePaid,
      // GoldRate: "" + payment.MetalCashRatePerGram,
      // SilverRate: "" + payment.MetalCashRatePerGram,
      // OldGoldGrosswt: "" + payment.MetalFinePaid,
      // OldSilverGrosswt: "" + payment.MetalFinePaid,
      // SilverAmount: `${payment.goldAmount}`,
      // GoldAmount: `${payment.silverAmount}`,
      MetalType: payment?.MetalType,
      FineGold: goldCategoryIds.includes(+(data.skus[0]?.SKUId || 0))
        ? "" + payment.MetalFinePaid
        : "",
      FineSilver: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalFinePaid
        : "",

      GoldRate: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalCashRatePerGram
        : "",
      SilverRate: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalCashRatePerGram
        : "",
      GoldAmount: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? `${+(payment?.MetalCashTotalAmount || 0)}`
        : "",
      SilverAmount: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? `${+(payment?.MetalCashTotalAmount || 0)}`
        : "",
      OldGoldGrossWt: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalFinePaid
        : "",
      OldSilverGrossWt: silverCategoryIds.includes(
        +(data.skus[0].CategoryId || 0)
      )
        ? "" + payment.MetalFinePaid
        : "",

      OtherMetalGrossWt: "0",
      GoldPurity: "",
      SilverPurity: "",
      OtherMetalPurity: "",
      PurchaseOrderId: 0,
      OrderId: 0,
      InvoiceId: 0,
      RDPurchaseId: 0,
      CustomerName: `${data?.customerName?.label}`,
      VendorName: "",
      InwardNo: "0",
      Status: "Sold",
      TDS: "0",
    };
  });

  const formData = {
    ...data,
    ClientCode: clientCode,
    CustomerId: `${data?.customerName?.value}` || "",
    Billedby: `${
      data?.selectedCashierEmployee ||
      `${employeeFirstName} ${employeeLastName}`
    }`,
    SaleType: "Sale",
    Soldby: `${data?.selectedSalesEmployee || employeeFirstName}`,
    PaymentMode: `${paymentsString}`,
    UrdPurchaseAmt: `${parseFloat(urdPurchaseAmt)?.toFixed(3)}`, // we dont have this
    GST: `${parseFloat(data?.TotalGst)?.toFixed(3)}`,
    ReceivedAmount: parseFloat(data?.TotalPaidAmount)?.toFixed(2),
    InvoiceStatus:
      data?.wholesaleProductList?.length > 0 ? "Invoice Created" : "Delivered", // from where we will get this wholesaleProductList
    Visibility: data?.gstCheckboxConfirm ? "Visible" : "Hidden",

    Offer: `${data?.TotalRODiscount || 0}`,
    TotalAmount: `${parseFloat(data?.TotalTaxableAmount).toFixed(3)}`,
    BillType: `${data?.gstCheckboxConfirm}`,
    InvoiceDate: `${data?.invoiceDate || getTodaysDateFormat()}`,
    InvoiceNo: data?.invoiceNumber,

    BalanceAmt: `${parseInt(grandTotal)}`,
    CreditAmount: "0",
    CreditGold: "0",
    CreditSilver: "0",
    GrossWt: `${totalGrossWt}`,
    NetWt: `${totalNetWt}`,
    StoneWt: `${totalStoneWt.toFixed(3)}`,
    Qty: `${totalQuantity}`,

    TotalDiamondAmount: "0",
    TotalDiamondPieces: "0",
    TotalDiamondWeight: "0",
    TotalSaleGold: "0",
    TotalSaleSilver: "0",
    TotalSaleUrdGold: "0",
    TotalSaleUrdSilver: "0",
    TotalStoneAmount: "0",
    TotalStonePieces: "0",
    TotalStoneWeight: "0",

    BalanceGold: "0",
    BalanceSilver: "0",
    OrderType: "Tax Invoice", // not clear what to do
    // pendingApproval
    //  ? "Pending Approval"
    //  : !pendingApproval && !applyGstAmount
    //    ? "Estimate"
    //    : "Tax Invoice",

    InvoiceItem: orderItemsList,
    Payments: paymentsList,

    TotalNetAmount: parseFloat(data?.TotalTaxableAmount || 0).toFixed(3),
    TotalFineMetal: parseFloat(data?.TotalFineMetal || 0).toFixed(3), //
    TotalBalanceMetal: parseFloat(data?.TotalBalanceMetal || 0).toFixed(3), //  not available
    GSTApplied: data?.gstCheckbox ? "true" : "false",
    gstCheckboxConfirm: data?.gstCheckboxConfirm ? "true" : "false",
    TotalGSTAmount: parseFloat(data?.TotalGst || 0).toFixed(3),
    Discount: parseFloat(data?.TotalRODiscount || 0).toFixed(3),
    TotalPurchaseAmount: parseFloat(data?.TotalBillAmount || 0).toFixed(3),
    BalanceAmount: parseFloat(data?.TotalBalanceAmount || 0).toFixed(3),
  };
  return formData;
}


export function getQuotationEntryFormData({
  data,
  customerList,
  clientCode,
  quotationDate,
  CompanyId,
  CounterId,
  BranchId,
  EmployeeId,
  employeeFirstName,
  employeeLastName,
}) {

  const paymentsString = data?.paymentTypes
    ?.map((payment) => `${payment.status}:${payment.amount}`)
    .join(",");
  const urdPurchaseAmt = 0; // not available in our system
  const totalPaidAmount = data?.paymentTypes.reduce(
    (total, payment) =>
      total +
      (payment.status !== "received" ? parseFloat(payment?.amount || 0) : 0),
    0
  );
  const allProdctsNetAmount = data?.skus?.reduce(
    (total, product) => total + +(product?.FinalPrice || 0),
    0
  );
  const grandTotal = +(data?.TotalTaxableAmount || 0) + +(data?.TotalGst || 0);
  const totalGrossWt = data?.skus?.reduce(
    (total, product) => total + +(product?.GrossWt || 0),
    0
  );
  const totalNetWt = data?.skus?.reduce(
    (total, product) => total + +(product?.NetWt || 0),
    0
  );
  const totalQuantity = data?.skus?.reduce(
    (a, b) => a + +(b?.Qty || b?.Pieces || 0),
    0
  );
  const totalStoneWt = data?.skus?.reduce((a, b) => a + +(b?.StoneWt || 0), 0);

  console.log(data);

  const orderItemsList = data?.skus?.map((product) => {
    return {
      QuotationItemId: 2,
      OldGoldPurchase: false,
      RatePerGram: '',
      PurchaseInvoiceNo: '',
      HallmarkNo: "",
      Description: '',
      StoneLessPercent: "",
      Amount: (+(product?.Amount || 0))?.toFixed(2),
      BillType: product?.OldGoldPurchase ? "purchase" : "sale",
      SKUId: product?.SKUId ? +(product?.SKUId ) : 0, // need to add
      SKU: product?.SKU ? `${product?.SKU}` : "", // need to add
      CategoryName: product.CategoryName ? `${product.CategoryName}` : "",
      CategoryId: product.CategoryId ? +product.CategoryId : "",
  
      ProductId: product.ProductId ? +(product.ProductId || 0): "",
      ProductName: product?.ProductName ? `${product?.ProductName}` : "",
      PurityId: product?.PurityId ?  +(product?.PurityId || 0) : "0",
      Purity: product?.PurityName ? `${product?.PurityName}` : "",
      DesignId: product?.DesignId ? `${(Number(product?.DesignId) || 0)}` : 0, // need to add
      DesignName: product?.DesignName ? `${product?.DesignName}` : "", // need to add
      TotalWt: product?.TotalWeight ? `${product?.TotalWeight}` : "",
      PackingWeight: product?.PackingWeight ? `${product?.PackingWeight}` : "",
      GrossWt: product?.GrossWt ? `${product?.GrossWt}` : "",
      TotalStoneWeight: product?.TotalStoneWeight
        ? `${product?.TotalStoneWeight}`
        : "",
      DiamondWeight: product?.DiamondWeight ? `${product?.DiamondWeight}` : "",
      NetWt: product?.NetWt ? `${product?.NetWt}` : "",
      MetalRate: product?.MetalRate ? `${product?.MetalRate}` : "", // little confusion is gold rate metal rate same ?
      Quantity: `${product?.Qty || 0}`,
      Pieces: `${product?.Pieces || 0}`,
      FinePercentage: product?.FinePercent ? `${product?.FinePercent}` : "",
      MakingPercentage: product?.MakingPercentages
        ? `${product?.MakingPercentage}`
        : "",
      MakingPerGram: product?.MakingPerGram ? `${product?.MakingPerGram}` : "",
      MakingFixedAmt: product?.MakingFixedAmt,
      MakingFixedWastage: product?.MakingFixedWastage,
      TotalStonePieces: product?.StonePieces, // need to add
      StonePieces: product?.StonePieces, // need to add Amount
      StoneAmount: `${product?.StoneAmount || product?.TotalStoneAmount}`,
      TotalStoneAmount: `${product?.StoneAmount || product?.TotalStoneAmount}`, // we dont have this
      HallmarkAmount: product?.HallmarkAmount,
      MetalAmount: `${product?.MetalAmount || 0}`,
      FineWt: product?.FineWt, // need to add
      WastageWt: product?.WastageWt,
      FineWastageWt: `${+(product?.FineWastageWt || 0)}`, // need to add
      CuttingGrossWt: product?.CuttingGrossWt,
      CuttingNetWt: product?.CuttingNetWt,
      MRP: `${product?.MRP}`,
      TotalItemAmount: `${product?.TotalItemAmount || 0}`,
  
      CustomerId: parseInt(data?.customerName?.value || 0),
  
      HSNCode: `${product?.HSNCode || ""}`,
  
      MakingCharg: product?.MakingCharg || "",
      ProductCode: "",
      ProductNo: "",
      NetAmount: product?.NetAmount,
      GSTAmount: product?.GSTAmount,
      totalGstAmount: product?.totalGstAmount,
      TotalAmount: product?.TotalAmount,
      finalPrice: product?.finalPrice,
      ConvertAmt: product?.ConvertAmt,
      MakingCharg: product?.Making ? `${product?.Making}` : "0",
      HUIDCode: product?.HUIDCode || "", // we don't have this
      Size: product?.Size || "", // we don't have this
      // OnlineStatus: "Billed",
      Price: `${(
        parseFloat(product?.FinalPrice || 0) +
        parseFloat(product?.TotalGST || 0)
      ).toFixed(3)}`,
      LabelledStockId: `${Number(product?.Id) || 0}` || 0, // Ensure LabelledStockId is present
      UnlProductId: `${(Number(product?.Id) || 0)}` || 0,
      Stones:
        product?.Stones && product?.Stones?.length > 0 ? product.Stones : [], // Ensure Stones array
      Diamonds:
        product?.Diamonds && product?.Diamonds?.length > 0
          ? product.Diamonds
          : [],
      ItemCode: product?.ItemCode || "",
      // Status: "Sold",
    };
  });

console.log(data);

 console.log(data?.skus?.VendorId);
 

 console.log(`${data?.quotationDate}`);
 

  const formData = {
    ClientCode: clientCode,
    CustomerId: `${data?.customerName?.value}` || "",
    VendorId: `${data?.VendorId || 0}`,
    CategoryId : 0,
    Date: `${data?.quotationDate}`,
    MRP : '',
    CuttingNetWt: "0",
    
    Billedby: `${
      data?.selectedCashierEmployee ||
      `${employeeFirstName} ${employeeLastName}`
    }`,
    SaleType: "Sale",
    Soldby: `${data?.selectedSalesEmployee || employeeFirstName}`,
    // added some fields
    CustomerName: `${employeeFirstName}`,
    FinancialYear: "2025",
  BaseCurrency: 'Rupees',
  PurchaseStatus: 'false',
  CompanyId: 20,
  BranchId: 22,
  CounterId: 39,
  EmployeeId: EmployeeId,
  TotalQuotationCount: '10',
  QuotationCount: '5',
  // CreatedOn: `${data?.quotationDate || 0}`,
  // LastUpdated: '12/3/2025',
  MobileNo: '9999999999',
  Email: 'loyal@gmail.com',
  FirstName: `${employeeFirstName}`,
  LastName: `${employeeLastName}`,
  DeliveryAddress: 'hinjawadi pune',
  AdvanceAmt: '100.000',
  LabelledStockId: 5002,
     // added some fields
    PaymentMode: `${paymentsString}`,
    UrdPurchaseAmt: `${(+(urdPurchaseAmt || 0))?.toFixed(3)}`, // we dont have this
    GST: `${(+(data?.TotalGst || 0))?.toFixed(3)}`,
    TDS: `${+(data?.additionalTax || 0)}`,
    ReceivedAmount: (+(data?.TotalPaidAmount || 0))?.toFixed(2),
    QuotationStatus:
      data?.wholesaleProductList?.length > 0 ? "Invoice Created" : "Delivered", // from where we will get this wholesaleProductList
    Visibility: data?.gstCheckbox ? "Visible" : "Hidden",

    Offer: `${data?.TotalRODiscount || 0}`,
    CourierCharge: `${+(data?.CourierCharge || 0)}`,
    TotalAmount: `${(+(data?.TotalTaxableAmount || 0))?.toFixed(3)}`,
    BillType: `${data?.gstCheckbox}`,
    

    QuotationDate: `${data?.quotationDate || getTodaysDateFormat()}`,
    QuotationNo: data?.quotationNumber,
    BalanceAmt: `${+(grandTotal || 0)}`,
    CreditAmount: "0",
    CreditGold: "0",
    CreditSilver: "0",
    GrossWt: `${totalGrossWt}`,
    NetWt: `${totalNetWt}`,
    StoneWt: `${totalStoneWt.toFixed(3)}`,
    Qty: `${totalQuantity}`,

    TotalDiamondAmount: "0",
    TotalDiamondPieces: "0",
    TotalDiamondWeight: "0",
    TotalSaleGold: "0",
    TotalSaleSilver: "0",
    TotalSaleUrdGold: "0",
    TotalSaleUrdSilver: "0",
    TotalStoneAmount: "0",
    TotalStonePieces: "0",
    TotalStoneWeight: "0",

    BalanceGold: "0",
    BalanceSilver: "0",
    // OrderType: "Tax Invoice", // not clear what to do
    // pendingApproval
    //  ? "Pending Approval"
    //  : !pendingApproval && !applyGstAmount
    //    ? "Estimate"
    //    : "Tax Invoice",

    QuotationItem: orderItemsList,
    // Payments: paymentsList,

    TotalNetAmount: parseFloat(data?.TotalTaxableAmount || 0).toFixed(3),
    TotalFineMetal: parseFloat(data?.TotalFineMetal || 0).toFixed(3), //
    TotalBalanceMetal: parseFloat(data?.TotalBalanceMetal || 0).toFixed(3), //  not available
    GSTApplied: data?.gstCheckbox ? "true" : "false",
    AdditionTaxApplied: data?.additionalTaxCheckbox ? "true" : "false",
    TotalGSTAmount: parseFloat(data?.TotalGst || 0).toFixed(3),
    Discount: parseFloat(data?.TotalRODiscount || 0).toFixed(3),
    TotalPurchaseAmount: parseFloat(data?.TotalBillAmount || 0).toFixed(3),
    BalanceAmount: parseFloat(data?.TotalBalanceAmount || 0).toFixed(3),
  };

  return formData;
}

export function getQuotationEditEntryFormData({
  data,
  customerList,
  clientCode,
  quotationDate,
  CompanyId,
  CounterId,
  BranchId,
  EmployeeId,
  employeeFirstName,
  employeeLastName,
}) {
  console.log(data);
  const paymentsString = data?.paymentTypes
    ?.map((payment) => `${payment.status}:${payment.amount}`)
    .join(",");
  const urdPurchaseAmt = 0; // not available in our system


  // const totalPaidAmount = data?.paymentTypes.reduce(
  //   (total, payment) =>
  //     total +
  //     (payment.status !== "received" ? parseFloat(payment?.amount || 0) : 0),
  //   0
  // );
  // const allProdctsNetAmount = data?.skus?.reduce(
  //   (total, product) => total + +(product?.FinalPrice || 0),
  //   0
  // );

  const grandTotal = +(data?.TotalTaxableAmount || 0) + +(data?.TotalGst || 0);
  const totalGrossWt = data?.skus?.reduce(
    (total, product) => total + +(product?.GrossWt || 0),
    0
  );
  const totalNetWt = data?.skus?.reduce(
    (total, product) => total + +(product?.NetWt || 0),
    0
  );
  const totalQuantity = data?.skus?.reduce(
    (a, b) => a + +(b?.Qty || b?.Pieces || 0),
    0
  );
  const totalStoneWt = data?.skus?.reduce((a, b) => a + +(b?.StoneWt || 0), 0);

  const orderItemsList = data?.skus?.map((product) => {
    console.log(product);
    
    return {
      Amount: (+(product?.Amount || 0))?.toFixed(2),
      BillType: product?.OldGoldPurchase ? "purchase" : "sale",
      SKUId: product?.SKUId ? `${product?.SKUId}` : "0", // need to add
      SKU: product?.SKU ? `${product?.SKU}` : "", // need to add
      CategoryName: product.CategoryName ? `${product.CategoryName}` : "",
      CategoryId: product.CategoryId ? `${product.CategoryId}` : "", // need to add
      ProductId: product.ProductId ? `${product.ProductId}` : "",
      ProductName: product?.ProductName ? `${product?.ProductName}` : "",
      PurityId: product?.PurityId ? `${+(product?.PurityId || 0)}` : "0",
      Purity: product?.PurityName ? `${product?.PurityName}` : "",
      DesignId: product?.DesignId ? `${+(product?.DesignId || 0)}` : "0", // need to add
      DesignName: product?.DesignName ? `${product?.DesignName}` : "", // need to add
      TotalWt: product?.TotalWeight ? `${product?.TotalWeight}` : "",
      PackingWeight: product?.PackingWeight ? `${product?.PackingWeight}` : "",
      GrossWt: product?.GrossWt ? `${product?.GrossWt}` : "",
      TotalStoneWeight: product?.TotalStoneWeight
        ? `${product?.TotalStoneWeight}`
        : "",
      DiamondWeight: product?.DiamondWeight ? `${product?.DiamondWeight}` : "",
      NetWt: product?.NetWt ? `${product?.NetWt}` : "",
      MetalRate: product?.MetalRate ? `${product?.MetalRate}` : "", // little confusion is gold rate metal rate same ?
      Quantity: `${product?.Qty || 0}`,
      Pieces: `${product?.Pieces || 0}`,
      FinePercentage: product?.FinePercent ? `${product?.FinePercent}` : "",
      MakingPercentage: product?.MakingPercentage
        ? `${product?.MakingPercentage}`
        : "",
      MakingPerGram: product?.MakingPerGram ? `${product?.MakingPerGram}` : "",
      MakingFixedAmt: product?.MakingFixedAmt,
      MakingFixedWastage: product?.MakingFixedWastage,
      TotalStonePieces: product?.StonePieces, // need to add
      StonePieces: product?.StonePieces, // need to add Amount
      StoneAmount: `${product?.StoneAmount || product?.TotalStoneAmount}`,
      TotalStoneAmount: `${product?.StoneAmount || product?.TotalStoneAmount}`, // we dont have this
      HallmarkAmount: product?.HallmarkAmount,
      MetalAmount: `${product?.MetalAmount || 0}`,
      FineWt: product?.FineWt, // need to add
      WastageWt: product?.WastageWt,
      FineWastageWt: `${+(product?.FineWastageWt || 0)}`, // need to add
      CuttingGrossWt: product?.CuttingGrossWt,
      CuttingNetWt: product?.CuttingNetWt,
      MRP: `${product?.MRP}`,
      TotalItemAmount: `${product?.TotalItemAmount || 0}`,

      CustomerId: parseInt(data?.customerName?.value || 0),

      HSNCode: `${product?.HSNCode || ""}`,

      MakingCharg: product?.MakingCharg || "",
      ProductCode: "",
      ProductNo: "",
      NetAmount: product?.NetAmount,
      GSTAmount: product?.GSTAmount,
      totalGstAmount: product?.totalGstAmount,
      TotalAmount: product?.TotalAmount,
      finalPrice: product?.finalPrice,
      ConvertAmt: product?.ConvertAmt,
      MakingCharg: product?.Making ? `${product?.Making}` : "0",
      HUIDCode: product?.HUIDCode || "", // we don't have this
      Size: product?.Size || "", // we don't have this
      OnlineStatus: "Billed",
      Price: `${(
        parseFloat(product?.FinalPrice || 0) +
        parseFloat(product?.TotalGST || 0)
      ).toFixed(3)}`,
      LabelledStockId: `${product?.Id || 0}` || "", // Ensure LabelledStockId is present
      UnlProductId: `${+(product?.Id || "")}` || "",
      Stones:
        product?.Stones && product?.Stones?.length > 0 ? product.Stones : [], // Ensure Stones array
      Diamonds:
        product?.Diamonds && product?.Diamonds?.length > 0
          ? product.Diamonds
          : [],
      ItemCode: product?.ItemCode || "",
      Status: "Sold",
      QuotationItemId: product?.QuotationItemId || "",
      StoneLessPercent: null,
      QuotationStatus: null,
      OldGoldPurchase: false,
      RatePerGram: product?.RatePerGram || "",
      PurProductNetWt: null,
      PurProductGrossWt: null,
      PurProductAmt: null,
      PurProductId: product?.PurProductId || 0,
      UnlProductNetWt: null,
      UnlProductGrossWt: null,
      UnlProductAmt: null,
      UnlProductId: product?.UnlProductId || 0,
      PurchaseInvoiceNo: '',
      HallmarkNo: '',
      Description: product?.Description || "",
      BaseCurrency: null,
      Quotationid: product?.Quotationid || 0,
      MetalName: null,
      Stones: null
    };
  });

  const currentYear = new Date().getFullYear();

  const paymentsList = data?.paymentTypes?.map((payment) => {
    return {
      ...payment,
      ClientCode: clientCode,
      PaymentSource: "Sale Bill",
      Description: payment?.description,
      PaymentModeType: `${payment?.mode}`,
      CreditDebit: "Credit",
      Amount: `${payment?.amount}`,
      amount: (+(payment?.amount || 0))?.toFixed(3),
      TransactionType: `${payment.status}`,
      // TransactionType: `${payment.paymentType}`,
      // TransactionType: "Receive",
      VendorId: 0,
      InvoiceNumber: data?.invoiceNumber,
      CustomerId: parseInt(data?.customerName?.value || ""),
      BillType: "sale",
      PaymentVisibility: "Active",
      FinancialYear: `${currentYear}`,
      Branch: "Home",
      CompanyId: CompanyId ? CompanyId : 0,
      CounterId: CounterId ? CounterId : 0,
      BranchId: BranchId ? BranchId : 0,
      EmployeId: EmployeeId ? EmployeeId : 0,
      // FineGold: "" + payment.MetalFinePaid,
      // FineSilver: "" + payment.MetalFinePaid,
      // GoldRate: "" + payment.MetalCashRatePerGram,
      // SilverRate: "" + payment.MetalCashRatePerGram,
      // OldGoldGrosswt: "" + payment.MetalFinePaid,
      // OldSilverGrosswt: "" + payment.MetalFinePaid,
      // SilverAmount: `${payment.goldAmount}`,
      // GoldAmount: `${payment.silverAmount}`,
      MetalType: payment?.MetalType,
      FineGold: goldCategoryIds.includes(+(data.skus[0]?.SKUId || 0))
        ? "" + payment.MetalFinePaid
        : "",
      FineSilver: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalFinePaid
        : "",

      GoldRate: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalCashRatePerGram
        : "",
      SilverRate: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalCashRatePerGram
        : "",
      GoldAmount: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? `${+(payment?.MetalCashTotalAmount || 0)}`
        : "",
      SilverAmount: silverCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? `${+(payment?.MetalCashTotalAmount || 0)}`
        : "",
      OldGoldGrossWt: goldCategoryIds.includes(+(data.skus[0].CategoryId || 0))
        ? "" + payment.MetalFinePaid
        : "",
      OldSilverGrossWt: silverCategoryIds.includes(
        +(data.skus[0].CategoryId || 0)
      )
        ? "" + payment.MetalFinePaid
        : "",

      OtherMetalGrossWt: "0",
      GoldPurity: "",
      SilverPurity: "",
      OtherMetalPurity: "",
      PurchaseOrderId: 0,
      OrderId: 0,
      InvoiceId: 0,
      RDPurchaseId: 0,
      CustomerName: `${data?.customerName?.label}`,
      VendorName: "",
      InwardNo: "0",
      Status: "Sold",
      TDS: "0",
    };
  });

  console.log(data);

  // Remove 'skus' from the original data object before using it in formData
const { skus, customerName,  ...processedData } = data;



console.log(processedData);





  const formData = {
    ...processedData,
    ClientCode: clientCode,
    // CustomerId: `${processedData?.CustomerId}` || 0,
    CustomerId: Number(processedData?.CustomerId) || 0,
    Date: `${processedData?.Date}`,
    MRP : '',
    CuttingNetWt: "0",
    BilledBy: `${
      processedData?.selectedCashierEmployee ||
      `${employeeFirstName} ${employeeLastName}`
    }`,
   
    SaleType: "Sale",
    SoldBy: `${processedData?.selectedSalesEmployee || employeeFirstName}`,
    PaymentMode: ``,
    UrdPurchaseAmt: `${parseFloat(urdPurchaseAmt)?.toFixed(3)}`, // we dont have this
    GST: `${parseFloat(processedData?.TotalGst)?.toFixed(3)}`,
    TDS: `${+(processedData?.additionalTax || 0)}`,

    ReceivedAmount: parseFloat(processedData?.TotalPaidAmount)?.toFixed(2),
    QuotationStatus:
    processedData?.wholesaleProductList?.length > 0 ? "Invoice Created" : "Delivered", // from where we will get this wholesaleProductList
    Visibility: processedData?.gstCheckbox ? "Visible" : "Hidden",
    CourierCharge: `${+(processedData?.CourierCharge || 0)}`,

    Offer: `${processedData?.TotalRODiscount || 0}`,
    TotalAmount: `${parseFloat(processedData?.TotalTaxableAmount).toFixed(3)}`,
    BillType: `${processedData?.gstCheckbox}`,
    QuotationDate: `${processedData?.quotationDate || getTodaysDateFormat()}`,
    QuotationNo: processedData?.QuotationNo,

    BalanceAmt: `${parseInt(grandTotal)}`,
    CreditAmount: "0",
    CreditGold: "0",
    CreditSilver: "0",
    GrossWt: `${totalGrossWt}`,
    NetWt: `${totalNetWt}`,
    StoneWt: `${totalStoneWt.toFixed(3)}`,
    Qty: `${totalQuantity}`,

    TotalDiamondAmount: "0",
    TotalDiamondPieces: "0",
    TotalDiamondWeight: "0",
    TotalSaleGold: "0",
    TotalSaleSilver: "0", 
    TotalSaleUrdGold: "0",
    TotalSaleUrdSilver: "0",
    TotalStoneAmount: "0",
    TotalStonePieces: "0",
    TotalStoneWeight: "0",

    BalanceGold: "0",
    BalanceSilver: "0",
    OrderType: "Tax Invoice", // not clear what to do
    // pendingApproval
    //  ? "Pending Approval"
    //  : !pendingApproval && !applyGstAmount
    //    ? "Estimate"
    //    : "Tax Invoice",

    QuotationItem: orderItemsList,
    // Payments: paymentsList,

    TotalNetAmount: parseFloat(processedData?.TotalTaxableAmount || 0).toFixed(3),
    TotalFineMetal: parseFloat(processedData?.TotalFineMetal || 0).toFixed(3), //
    TotalBalanceMetal: parseFloat(processedData?.TotalBalanceMetal || 0).toFixed(3), //  not available
    GSTApplied: processedData?.gstCheckbox ? "true" : "false",
    TotalGSTAmount: parseFloat(processedData?.TotalGst || 0).toFixed(3),
    Discount: parseFloat(processedData?.TotalRODiscount || 0).toFixed(3),
    TotalPurchaseAmount: parseFloat(processedData?.TotalBillAmount || 0).toFixed(3),
    BalanceAmount: parseFloat(processedData?.TotalBalanceAmount || 0).toFixed(3),
  };
  
  return formData;
}

export function convertInInvoiceWholeSaleFormat(data) {
  console.log(data);
  return {
    ...data,
    SKUId: data?.StockKeepingUnit?.value
      ? "" + +(data?.StockKeepingUnit?.value || 0)
      : "",
    SKU: data?.StockKeepingUnit?.label ? data?.StockKeepingUnit?.label : "",
    CategoryId: data?.CategoryId?.value,
    CategoryName: data?.CategoryId?.label,
    DesignId: data?.DesignId?.value,
    DesignName: data?.DesignId?.label,
    ProductId: data?.ProductId?.value,
    ProductName: data?.ProductId?.label,
    PurityId: data?.PurityId?.value,
    PurityName: data?.PurityId?.label,
    TotalWeight: (+(data?.TotalWt || 0))?.toFixed(3),
    PackingWeight: (+(data?.PackingWeight || 0))?.toFixed(3),
    GrossWt: (+(data?.GrossWt || 0))?.toFixed(3),
    TotalStoneWeight: (+(data?.StoneWt || 0))?.toFixed(3),
    TotalDiamondWeight: data?.DiamondWeight,
    DiamondWeight: data?.DiamondWeight,
    NetWt: (+(data?.NetWt || 0))?.toFixed(3),
    MetalRate: data?.GoldRate,
    Pieces: data?.Pieces,
    Qty: data?.Qty, // need to add in backend
    FinePercent: data?.FinePercent,
    MakingPercentage: data?.MakingPercent,
    MakingPerGram: data?.MakingPerGram,
    MakingFixedAmt: data?.MakingFixedAmt,
    MakingFixedWastage: data?.MakingFixedWastage,
    TotalStonePieces: data?.StonePieces,
    TotalStoneAmount: data?.StoneAmount || "0",
    HallmarkAmount: data?.Hallmark || "0",
    MetalAmount: data?.MetalAmount || "0", // need to add in backend
    CuttingGrossWt: data?.CuttingGrossWt, // need to add in backend
    CuttingNetWt: data?.CuttingNetWt, // need to add in backend
    MRP: data?.MRP,
  };
}

export function editInvoiceValueFormat(data, payments) {
  const paymentList = payments?.map((item) => {
    return {
      ...item,
      description: item?.Description,
      mode: item?.PaymentModeType,
      amount: item?.Amount,
      status: item?.TransactionType,
      invoiceNumber: item?.InvoiceNumber,
      MetalCashRatePerGram: item?.GoldRate || item?.SilverRate,
      MetalFinePaid: +(item?.OldGoldGrossWt || 0) || item?.OldSilverGrossWt,
      description: item?.Description,
      MetalCashTotalAmount: item?.GoldAmount || item?.SilverAmount,
      MetalType: item?.MetalType,
    };
  });


  
  const skuItems = data?.InvoiceItem?.map((item) => {
    return {
      ...item,
      SKU: item?.SKU,
      OldGoldPurchase: item?.BillType == "purchase" ? true : false,
      PurityName: item?.Purity,
      TotalWeight: item?.TotalWt,
      Qty: +item?.Quantity || 0,
      FinePercent: item?.FinePercentage,
    };
  });
  return {
    ...data,
    invoiceNumber: data?.InvoiceNo,
    invoiceDate: data?.InvoiceDate,

    balanceGold: data?.TotalBalanceMetal,
    TotalFineMetal: data?.TotalFineMetal, //
    TotalBalanceMetal: data?.TotalBalanceMetal, //  not available
    TotalTaxableAmount: data?.TotalNetAmount || "0.000",
    gstCheckbox: data?.GSTApplied == "true" ? true : false,
    gstCheckboxConfirm: data?.gstCheckboxConfirm == "true" ? true : false,
    TotalGst: data?.TotalGSTAmount || "0.000",
    TotalRODiscount: data?.Discount || "0.000",
    TotalBillAmount: data?.TotalPurchaseAmount || "0.000",
    TotalBalanceAmount: data?.BalanceAmount || "0.000",

    customerName: {
      value: data?.Customer?.Id,
      label: data.Customer?.FirstName,
    },
    paymentTypes: paymentList,
    skus: skuItems,
  };
}
export function editQuotationValueFormat(data, payments) {
  const paymentList = payments?.map((item) => {
    return {
      ...item,
      description: item?.Description,
      mode: item?.PaymentModeType,
      amount: item?.Amount,
      status: item?.TransactionType,
      invoiceNumber: item?.InvoiceNumber,
      MetalCashRatePerGram: item?.GoldRate || item?.SilverRate,
      MetalFinePaid: +(item?.OldGoldGrossWt || 0) || item?.OldSilverGrossWt,
      description: item?.Description,
      MetalCashTotalAmount: item?.GoldAmount || item?.SilverAmount,
      MetalType: item?.MetalType,
    };
  });


  
  const skuItems = data?.QuotationItem?.map((item) => {
    return {
      ...item,
      SKU: item?.SKU,
      OldGoldPurchase: item?.BillType == "purchase" ? true : false,
      PurityName: item?.Purity,
      TotalWeight: item?.TotalWt,
      Qty: +item?.Quantity || 0,
      FinePercent: item?.FinePercentage,
    };
  });
  return {
    ...data,
    invoiceNumber: data?.InvoiceNo,
    invoiceDate: data?.InvoiceDate,

    balanceGold: data?.TotalBalanceMetal,
    TotalFineMetal: data?.TotalFineMetal, //
    TotalBalanceMetal: data?.TotalBalanceMetal, //  not available
    TotalTaxableAmount: data?.TotalNetAmount || "0.000",
    gstCheckbox: data?.GSTApplied == "true" ? true : false,
    TotalGst: data?.TotalGSTAmount || "0.000",
    TotalRODiscount: data?.Discount || "0.000",
    TotalBillAmount: data?.TotalPurchaseAmount || "0.000",
    TotalBalanceAmount: data?.BalanceAmount || "0.000",

    customerName: {
      value: data?.Customer?.Id,
      label: data.Customer?.FirstName,
    },
    paymentTypes: paymentList,
    skus: skuItems,
  };
}

export function resetValues(setValue) {
  setValue("StockKeepingUnit", "");
  setValue("CategoryId", "");
  setValue("ProductId", "");
  setValue("DesignId", "");
  setValue("PurityId", "");
  setValue("TotalWt", "");
  setValue("PackingWeight", "");
  setValue("GrossWt", "");
  setValue("StoneWt", "");
  setValue("DiamondWeight", "");
  setValue("NetWt", "");
  setValue("GoldRate", "");
  setValue("Qty", "");
  setValue("FinePercent", "");
  setValue("MakingPercent", "");
  setValue("MakingPerGram", "");
  setValue("MakingFixedAmt", "");
  setValue("MakingFixedWastage", "");
  setValue("StonePieces", "");
  setValue("StoneAmount", "");
  setValue("Hallmark", "");
  setValue("MetalAmount", "");
  setValue("TotalMakingAmount", "");
  setValue("TotalItemAmount", "");
  setValue("FineWt", "");
  setValue("WastageWt", "");
  setValue("FineWastageWt", "");
  setValue("CuttingGrossWt", "");
  setValue("CuttingNetWt", "");
  setValue("MRP", "");
  setValue("RatePerGram", "");
  setValue("Amount", "");
}

export function getCurrentFinancialYear() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // January is 0, February is 1, ..., December is 11

  // If the current month is before April (0, 1, 2), it's part of the previous financial year
  if (month < 3) {
    return `${year - 1}-${year}`;
  } else {
    return `${year}-${year + 1}`;
  }
}

export const VendorTounchSkuColumns = [
  { key: "serialNumber", label: "Sr.No", type: "read", priority: 1 },
  { key: "StockKeepingUnit", label: "SKU", type: "read", priority: 2 },
  { key: "CategoryName", label: "Category", type: "read", priority: 3 },
  { key: "ProductName", label: "Product", type: "read", priority: 4 },
  { key: "PurityName", label: "Purity", type: "read", priority: 5 },
  { key: "Pieces", label: "Pieces", type: "read", priority: 6 },
  { key: "SketchNo", label: "Sketch Number", type: "read", priority: 7 },
  {
    key: "WeightCategories",
    label: "Weight Categories",
    type: "read",
    priority: 8,
  },
];
export const VendorTounchStonesColumns = [
  { key: "serialNumber", label: "Sr.No", type: "read", priority: 1 },
  { key: "StoneName", label: "Stone Name", type: "read", priority: 2 },
  { key: "StoneRate", label: "Rate/Gm", type: "read", priority: 3 },
];

export const VendorTouncListColumns = [
  { key: "serialNumber", label: "Sr.No", type: "read", priority: 1 },
  { key: "VendorName", label: "Vendor", type: "read", priority: 2 },
  { key: "CategoryName", label: "Category", type: "read", priority: 3 },
  { key: "ProductName", label: "Product", type: "read", priority: 4 },
  { key: "DesignName", label: "Design", type: "read", priority: 5 },
  { key: "PurityName", label: "Purity", type: "read", priority: 6 },
  { key: "FinePercentage", label: "Fine %", type: "read", priority: 6 },
  { key: "StockKeepingUnit", label: "SKU", type: "read", priority: 7 },
  // { key: "WastageWt", label: "Wastage", type: "read", priority: 8 },
  {
    key: "MakingFixedAmt",
    label: "Making FixedAmt",
    type: "read",
    priority: 9,
  },
  {
    key: "MakingPercentage",
    label: "Making %	",
    type: "read",
    priority: 10,
  },
  {
    key: "MakingPerGram",
    label: "Making/Gram",
    type: "read",
    priority: 11,
  },
  {
    key: "DiamondSizeWeightRateTemplateName",
    label: "Template Name",
    type: "read",
    priority: 12,
  },
];

export const CustomerTounchListColumns = [
  { key: "serialNumber", label: "Sr.No", type: "read", priority: 1 },
  { key: "FirstName", label: "Customer", type: "read", priority: 2 },
  { key: "CategoryName", label: "Category", type: "read", priority: 3 },
  { key: "ProductName", label: "Product", type: "read", priority: 4 },
  { key: "DesignName", label: "Design", type: "read", priority: 5 },
  { key: "PurityName", label: "Purity", type: "read", priority: 6 },
  { key: "StockKeepingUnit", label: "SKU", type: "read", priority: 7 },
  // { key: "Wastage", label: "Wastage", type: "read", priority: 8 },
  {
    key: "MakingFixedAmt",
    label: "Making FixedAmt",
    type: "read",
    priority: 9,
  },
  {
    key: "MakingPercentage",
    label: "Making Percentage	",
    type: "read",
    priority: 10,
  },
  {
    key: "MakingPerGram",
    label: "Making PerGram",
    type: "read",
    priority: 11,
  },
  {
    key: "DiamondSizeWeightRateTemplateId",
    label: "Template Name",
    type: "read",
    priority: 12,
  },
];

export const SkuListColumn = [
  { key: "serialNumber", label: "ID", type: "read", priority: 1 },
  { key: "StockKeepingUnit", label: " SKU", type: "read", priority: 2 },
  { key: "DesignName", label: "Design", type: "read", priority: 2 },
  { key: "Vendor", label: "Vendor", type: "read", priority: 3 },
  { key: "CategoryName", label: "Category", type: "read", priority: 3 },
  { key: "ProductName", label: "Product", type: "read", priority: 3 },
  // { key: "DesignName", label: "Design", type: "read", priority: 3 },
  { key: "PurityName", label: "Purity", type: "read", priority: 3 },
  { key: "Description", label: "Description", type: "read", priority: 3 },
];

export const purchaseListColumns = [
  { key: "serialNumber", label: "S No", type: "read", priority: 2 },
  { key: "InvoiceNo", label: "InvoiceNo", type: "read", priority: 1 },

  { key: "LotNumber", label: "Lot No", type: "read", priority: 3 },
  { key: "VendorName", label: "Vendor Name", type: "read", priority: 5 },
  { key: "GrossWt", label: "GrossWt", type: "read", priority: 4 },
  { key: "NetWt", label: "NetWt", type: "read", priority: 5 },
  // { key: "null", label: "F%+W%", type: "read", priority: 6 },
  { key: "TotalFineWithWstageWt", label: "F+W Wt", type: "read", priority: 7 },
  { key: "TotalNetAmount", label: "Invoice Amount", type: "read", priority: 8 },
  { key: "TotalGSTAmount", label: "GST Amount", type: "read", priority: 9 },
  {
    key: "TotalPurchaseAmount",
    label: "Net Amount",
    type: "read",
    priority: 10,
  },
  { key: "PaidAmount", label: "Paid Amount", type: "read", priority: 11 },
  { key: "PaidMetal", label: "Paid Metal", type: "read", priority: 12 },
  { key: "BalanceAmount", label: "Balance Amount", type: "read", priority: 13 },
];

export const stockListColumns = [
  { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
  // { key: "ProductCode", label: "Date", type: "read", priority: 7 },
  { key: "ItemCode", label: "Item Code", type: "read", priority: 5 },
  // { key: "null", label: "F%+W%", type: "read", priority: 6 },
  { key: "RFIDCode", label: "RFID Code", type: "read", priority: 7 },
  { key: "ProductCode", label: "Product Code", type: "read", priority: 7 },
  { key: "SKU", label: "SKU", type: "read", priority: 4 },
  { key: "CategoryName", label: "Category", type: "read", priority: 1 },

  { key: "ProductName", label: "Product", type: "read", priority: 3 },
  { key: "DesignName", label: "Design", type: "read", priority: 5 },
  { key: "PurityName", label: "Purity Name", type: "read", priority: 5 },
  
  // { key: "ProductCode", label: "QTY", type: "read", priority: 7 },
  { key: "GrossWt", label: "Gross Wt", type: "read", priority: 8 },
  { key: "TotalStoneWeight", label: "Stone Wt", type: "read", priority: 9 },
  { key: "TotalStonePieces", label: "Stone Pcs", type: "read", priority: 9 },
  { key: "TotalDiamondWeight", label: "Diamond Wt", type: "read", priority: 9 },
  { key: "TotalDiamondPieces", label: "Diamond Pcs", type: "read", priority: 9 },
  {
    key: "NetWt",
    label: "Net Wt",
    type: "read",
    priority: 10,
  },
  { key: "Pieces", label: "Pieces", type: "read", priority: 9 },
  { key: "TotalStoneAmount", label: "Stone Amt", type: "read", priority: 11 },
  { key: "MRP", label: "MRP", type: "read", priority: 12 },
  { key: "MakingFixedWastage", label: "Fixed Wastage", type: "read", priority: 13 },
  { key: "MakingFixedAmt", label: "Fixed Amt", type: "read", priority: 13 },
  { key: "PacketName", label: "Packet", type: "read", priority: 13 },
  { key: "ClipWeight", label: "Clip Wt", type: "read", priority: 13 },
  { key: "BoxName", label: "Box Name", type: "read", priority: 13 },
  { key: "VendorName", label: "Vendor", type: "read", priority: 13 },
  { key: "BranchName", label: "Branch", type: "read", priority: 13 },
];

export const reportsByCategory = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "Category", label: "Category", type: "read", priority: 1 },

  { key: "OpeningQuantity", label: "Opening Qty", type: "read", priority: 3 },
  {
    key: "OpeningGrossWeight",
    label: "Opening Gr Wt",
    type: "read",
    priority: 5,
  },
  {
    key: "OpeningNetWeight",
    label: "Opening Net Wt",
    type: "read",
    priority: 4,
  },
  {
    key: "StockEntryQuantity",
    label: "Stock In Qty",
    type: "read",
    priority: 5,
  },
  { key: "StockEntryGrWt", label: "Stock In Gr Wt", type: "read", priority: 6 },
  { key: "SaleQty", label: "Sale Qty", type: "read", priority: 7 },
  { key: "SaleGrossWt", label: "Sale Gross Wt", type: "read", priority: 8 },
  { key: "ClosingQty", label: "Closing Qty", type: "read", priority: 9 },
  {
    key: "ClosingGrossWeight",
    label: "Closing Gr Wt",
    type: "read",
    priority: 10,
  },
  {
    key: "ClosingNetWeight",
    label: "Closing Net Wt",
    type: "read",
    priority: 11,
  },
];
export const reportsByProduct = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "Product", label: "Product", type: "read", priority: 1 },

  { key: "OpeningQuantity", label: "Opening Qty", type: "read", priority: 3 },
  {
    key: "OpeningGrossWeight",
    label: "Opening Gr Wt",
    type: "read",
    priority: 5,
  },
  {
    key: "OpeningNetWeight",
    label: "Opening Net Wt",
    type: "read",
    priority: 4,
  },
  {
    key: "StockEntryQuantity",
    label: "Stock In Qty",
    type: "read",
    priority: 5,
  },
  { key: "StockEntryGrWt", label: "Stock In Gr Wt", type: "read", priority: 6 },
  { key: "SaleQty", label: "Sale Qty", type: "read", priority: 7 },
  { key: "SaleGrossWt", label: "Sale Gross Wt", type: "read", priority: 8 },
  { key: "ClosingQty", label: "Closing Qty", type: "read", priority: 9 },
  {
    key: "ClosingGrossWeight",
    label: "Closing Gr Wt",
    type: "read",
    priority: 10,
  },
  {
    key: "ClosingNetWeight",
    label: "Closing Net Wt",
    type: "read",
    priority: 11,
  },
];

export const reportsByDesign = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "Design", label: "Design", type: "read", priority: 1 },

  { key: "OpeningQuantity", label: "Opening Qty", type: "read", priority: 3 },
  {
    key: "OpeningGrossWeight",
    label: "Opening Gr Wt",
    type: "read",
    priority: 5,
  },
  {
    key: "OpeningNetWeight",
    label: "Opening Net Wt",
    type: "read",
    priority: 4,
  },
  {
    key: "StockEntryQuantity",
    label: "Stock In Qty",
    type: "read",
    priority: 5,
  },
  { key: "StockEntryGrWt", label: "Stock In Gr Wt", type: "read", priority: 6 },
  { key: "SaleQty", label: "Sale Qty", type: "read", priority: 7 },
  { key: "SaleGrossWt", label: "Sale Gross Wt", type: "read", priority: 8 },
  { key: "ClosingQty", label: "Closing Qty", type: "read", priority: 9 },
  {
    key: "ClosingGrossWeight",
    label: "Closing Gr Wt",
    type: "read",
    priority: 10,
  },
  {
    key: "ClosingNetWeight",
    label: "Closing Net Wt",
    type: "read",
    priority: 11,
  },
];
export const reportsBySkuKarigar = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "SKU", label: "SKU", type: "read", priority: 1 },
  { key: "DesignName", label: "Design", type: "read", priority: 1 },

  {
    key: "PlaneWeightByCategories",
    label: "Weight Categories",
    type: "read",
    priority: 3,
  },
  {
    key: "TotalStoneWeight",
    label: "Total Stone Wt",
    type: "read",
    priority: 5,
  },
  { key: "AvailableWt", label: "Total Gross Wt", type: "read", priority: 4 },
];
export const reportsBySKU = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "SKU", label: "SKU", type: "read", priority: 1 },

  { key: "ItemName", label: "Item Name", type: "read", priority: 3 },
  { key: "Quantity", label: "Qty", type: "read", priority: 5 },
  { key: "TotalWeight", label: "Total Wt", type: "read", priority: 4 },
  { key: "PackingWeight", label: "Packing Wt", type: "read", priority: 5 },
  { key: "GrossWeight", label: "Gross Wt", type: "read", priority: 6 },
  { key: "StonePcs", label: "Stone Pcs", type: "read", priority: 7 },
  { key: "StoneWeight", label: "Stone Wt", type: "read", priority: 8 },
  { key: "NetWeight", label: "Net Wt", type: "read", priority: 9 },
  {
    key: "ClosingGrossWeight",
    label: "Fine Wt+W Wt",
    type: "read",
    priority: 10,
  },
];

export const reportsLabelledStock = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "CategoryName", label: "Category", type: "read", priority: 1 },
  { key: "ProductName", label: "Product", type: "read", priority: 1 },
  { key: "DesignName", label: "Design", type: "read", priority: 1 },

  { key: "SKU", label: "SKU", type: "read", priority: 3 },
  { key: "ItemCode", label: "Item Code", type: "read", priority: 5 },
  { key: "RFIDCode", label: "RFID Code", type: "read", priority: 4 },
  { key: "GrossWt", label: "Gross Wt", type: "read", priority: 5 },
  { key: "TotalStoneWeight", label: "Stone Wt", type: "read", priority: 6 },
  { key: "ClipWeight", label: "Clip Wt", type: "read", priority: 7 },
  { key: "NetWt", label: "Net Wt", type: "read", priority: 8 },
  { key: "MRP", label: "MRP", type: "read", priority: 9 },
  { key: "PacketName", label: "Packet Name", type: "read", priority: 10 },
  { key: "BoxName", label: "Box Name", type: "read", priority: 11 },
  { key: "VendorName", label: "Vendor Name", type: "read", priority: 12 },
];
export const invoiceListColumns = [
  { key: "serialNumber", label: "S No", type: "read", priority: 2 },
  { key: "InvoiceNo", label: "Invoice No", type: "read", priority: 1 },
  { key: "ProductCode", label: "Product Code", type: "read", priority: 1 },

  // { key: "LotNumber", label: "Lot No", type: "read", priority: 3 },
  { key: "CustomerId", label: "Customer Name", type: "read", priority: 5 },
  { key: "GrossWt", label: "Gross Wt", type: "read", priority: 4 },
  { key: "NetWt", label: "Net Wt", type: "read", priority: 5 },
  // { key: "null", label: "F%+W%", type: "read", priority: 6 },
  { key: "TotalFineMetal", label: "F+W Wt", type: "read", priority: 7 },
  { key: "TotalNetAmount", label: "Invoice Amount", type: "read", priority: 8 },
  { key: "TotalGSTAmount", label: "GST Amount", type: "read", priority: 9 },
  {
    key: "TotalPurchaseAmount",
    label: "Net Amount",
    type: "read",
    priority: 10,
  },
  { key: "ReceivedAmount", label: "Paid Amount", type: "read", priority: 11 },
  { key: "PaidMetal", label: "Paid Metal", type: "read", priority: 12 },
  { key: "BalanceAmount", label: "Balance Amount", type: "read", priority: 13 },
];





export const quotationListColumns = [
  { key: "serialNumber", label: "S No", type: "read", priority: 2 },
  { key: "QuotationNo", label: "Quotation No", type: "read", priority: 1 },

  // { key: "LotNumber", label: "Lot No", type: "read", priority: 3 },
  { key: "CustomerId", label: "Customer Name", type: "read", priority: 5 },
  { key: "GrossWt", label: "Gross Wt", type: "read", priority: 4 },
  { key: "NetWt", label: "Net Wt", type: "read", priority: 5 },
  // { key: "null", label: "F%+W%", type: "read", priority: 6 },
  { key: "TotalFineMetal", label: "F+W Wt", type: "read", priority: 7 },
  { key: "TotalAmount", label: "Quotation Amount", type: "read", priority: 8 },
  { key: "TotalGSTAmount", label: "GST Amount", type: "read", priority: 9 },
  {
    key: "TotalPurchaseAmount",
    label: "Net Amount",
    type: "read",
    priority: 10,
  },
  // { key: "ReceivedAmount", label: "Paid Amount", type: "read", priority: 11 },
  // { key: "PaidMetal", label: "Paid Metal", type: "read", priority: 12 },
  { key: "BalanceAmount", label: "Balance Amount", type: "read", priority: 13 },
];


export const collectListColumns = [
  { key: "serialNumber", label: "S No", type: "read", priority: 2 },
  { key: "QuotationNo", label: "Date", type: "read", priority: 1 },

  // { key: "LotNumber", label: "Lot No", type: "read", priority: 3 },
  { key: "CustomerId", label: "Customer Name", type: "read", priority: 5 },
  { key: "CustomerId", label: "Contact No", type: "read", priority: 5 },
  { key: "GrossWt", label: "Area", type: "read", priority: 4 },
  { key: "NetWt", label: "Enrollment No", type: "read", priority: 5 },
  // { key: "null", label: "F%+W%", type: "read", priority: 6 },
  { key: "TotalFineMetal", label: "Collected Amount", type: "read", priority: 7 },
  { key: "TotalNetAmount", label: "Due Amount", type: "read", priority: 8 },
  { key: "TotalGSTAmount", label: "Maturity Amount", type: "read", priority: 9 },
 
];


export const schemeInstallmentListColumns = [
  { key: "serialNumber", label: "S No", type: "read", priority: 2 },
  { key: "InvoiceNo", label: "Scheme Name", type: "read", priority: 1 },

  // { key: "LotNumber", label: "Lot No", type: "read", priority: 3 },
  { key: "CustomerId", label: "Enrollment No", type: "read", priority: 5 },
  { key: "GrossWt", label: "Scheme Start Date", type: "read", priority: 4 },
  { key: "NetWt", label: "Scheme Maturity Date", type: "read", priority: 5 },
  // { key: "null", label: "F%+W%", type: "read", priority: 6 },
  { key: "TotalFineMetal", label: "Customer Name", type: "read", priority: 7 },
  { key: "TotalNetAmount", label: "Investment Amount", type: "read", priority: 8 },
  { key: "TotalGSTAmount", label: "Maturity Amount", type: "read", priority: 9 },
 
];


export const customerTxList = [
  { key: "serialNumber", label: "S No", type: "read", priority: 2 },
  { key: "CustomerId", label: "Customer Name", type: "read", priority: 5 },
  { key: "Date", label: "Date", type: "read", priority: 1 },

  // { key: "LotNumber", label: "Lot No", type: "read", priority: 3 },
  { key: "Description", label: "Description", type: "read", priority: 4 },
  { key: "PaymentType", label: "Payment Type", type: "read", priority: 5 },
  // { key: "null", label: "F%+W%", type: "read", priority: 6 },
  { key: "PaymentMode", label: "Payment Mode", type: "read", priority: 7 },
  { key: "Gold", label: "gold", type: "read", priority: 8 },
  { key: "Silver", label: "Silver", type: "read", priority: 9 },
  {
    key: "Amount",
    label: "Amount",
    type: "read",
    priority: 10,
  },
  // { key: "ReceivedAmount", label: "Paid Amount", type: "read", priority: 11 },
  // { key: "PaidMetal", label: "Paid Metal", type: "read", priority: 12 },
  // { key: "BalanceAmount", label: "Balance Amount", type: "read", priority: 13 },
];
export const addStoneCategory = [{ StoneValue: "COLOR STONE", Id: "12" }];

export function calculateAmount(data, customerTounch) {
  let StoneAmount = 0;
  console.log(data);
  if (
    data?.Stones?.length &&
    customerTounch?.length &&
    customerTounch[0]?.Stones?.length
  ) {
    data.Stones.forEach((stoneItem, index) => {
      const filteredItem = customerTounch[0]?.Stones?.filter(
        (tounchStone) => tounchStone?.StoneName == stoneItem?.StoneName
      );

      if (filteredItem?.length) {
        stoneItem.StoneRateKarate = `${+(filteredItem[0]?.StoneRate || 0)}`;
        stoneItem.StoneAmount = `${
          +(stoneItem?.StoneWeight || 0) * +(stoneItem.StoneRateKarate || 0)
        }`;

        StoneAmount +=
          +(stoneItem?.StoneWeight || 0) * +(stoneItem.StoneRateKarate || 0);
      }
    });
  } else if (data?.TotalStoneAmount) {
    StoneAmount = data?.TotalStoneAmount;
  } else {
    StoneAmount = "0";
  }
  console.log(StoneAmount);
  return {
    ...data,
    Qty: !+(data?.Qty || 0) ? 1 : data?.Qty,
    ...(+(data?.TotalWeight || 0)
      ? { TotalWeight: (+(data?.TotalWeight || 0))?.toFixed(3) }
      : { TotalWeight: (+(data?.GrossWt || 0))?.toFixed(3) }),
    MetalAmount: (+(data?.MetalRate || 0) * +(data?.NetWt || 0))?.toFixed(3),
    ...(+(data?.MetalRate || 0)
      ? {
          TotalItemAmount: (
            +(+(data?.MetalRate || 0) * +(data?.NetWt || 0) || 0) +
            +(
              (+(data?.MakingPercentage || 0) / 100) *
                +(data?.NetWt || 0) *
                +(data?.MetalRate || 0) +
                +(data?.MakingPerGram || 0) * +(data?.NetWt || 0) +
                +(data?.MetalRate || 0) * +(data?.MakingFixedWastage || 0) +
                +(data?.MakingFixedAmt || 0) || 0
            ) +
            +(StoneAmount || 0) +
            +(data?.HallmarkAmount || 0) +
            +(data?.TotalDiamondAmount || 0)
          )?.toFixed(3),
        }
      : {
          TotalItemAmount: (
            +(data?.MakingPerGram || 0) * +(data?.NetWt || 0) +
            +(data?.MakingFixedAmt || 0) +
            +(data?.HallmarkAmount || 0) +
            +(StoneAmount || 0) +
            +(data?.TotalDiamondAmount || 0)
          )?.toFixed(3),
        }),

    ...(+(data?.MetalRate || 0)
      ? {
          TotalMakingAmount: +(
            (+(data?.MakingPercentage || 0) / 100) *
              +(data?.NetWt || 0) *
              +(data?.MetalRate || 0) +
              +(data?.MakingPerGram || 0) * +(data?.NetWt || 0) +
              +(data?.MetalRate || 0) * +(data?.MakingFixedWastage || 0) +
              +(data?.MakingFixedAmt || 0) || 0
          ),
        }
      : {
          TotalMakingAmount: +(
            +(data?.MakingPerGram || 0) * +(data?.NetWt || 0) +
              +(data?.MakingFixedAmt || 0) || 0
          ),
        }),
    ...(+(data?.MetalRate || 0)
      ? {
          FineWt: "",
          WastageWt: "",
          FineWastageWt: "",
        }
      : {
          FineWt: +(
            (+(data?.FinePercent || 0) * +(data?.NetWt || 0)) / 100 || 0
          )?.toFixed(3),
          WastageWt: +(
            (+(data?.MakingPercentage || 0) * +(data?.NetWt || 0)) / 100 +
              +(data?.MakingFixedWastage || 0) || 0
          )?.toFixed(3),
          FineWastageWt: +(
            +((+(data?.FinePercent || 0) * +(data?.NetWt || 0)) / 100 || 0) +
              +(
                (+(data?.MakingPercentage || 0) * +(data?.NetWt || 0)) / 100 ||
                0
              ) +
              +(data?.MakingFixedWastage || 0) || 0
          )?.toFixed(3),
        }),
    ...{
      TotalStoneAmount: (+(StoneAmount || 0))?.toFixed(3),
      StonePieces: data?.TotalStonePieces,
      // StoneAmount: StoneAmount,
    },
  };
}

const stockTypeList = [
  {
    value: "Labelled",
    label: "Labelled",
  },
  {
    value: "UnLabelled",
    label: "Unlabelled",
  },
];
export function getDropDownListAddStock({
  key,
  branchOption,
  vendorList,
  skus,
  LotList,
  LotNumber,
  Vendor,
  SKUId
}) {
  console.log(key);
  console.log(skus);
  console.log(LotNumber);
  if (key == "StockType") {
    return stockTypeList;
  } else if (key == "Branch") {
    return branchOption?.length
      ? branchOption?.map((item) => {
          return {
            value: item?.Id,
            label: item?.BranchName,
          };
        })
      : [];
  } else if (key == "VendorId") {
    if(LotNumber || SKUId){
    let  result = vendorList?.map((item)=>{return{value:item?.Id,label:item?.VendorName}})
    console.log(skus)
    console.log(result)
    console.log(SKUId)
    if(LotNumber){
      result = result?.filter((item)=>item?.value == LotNumber?.value)
    
    }

    if(SKUId && skus?.length){
      let foundSku = skus?.find((item)=>item?.Id == SKUId?.value)
      console.log(foundSku)
      let skuVendor = foundSku?.SKUVendor?.map((item)=>item?.VendorId)
      console.log(skuVendor)
      result = result?.filter((item)=>skuVendor.includes(item?.value))
      console.log(result)
    }
    return result
  }else{
    return vendorList?.length
      ? vendorList?.map((item) => {
         
          return {
            value: item?.Id,
            label: item?.VendorName,
          };
        })
      : [];
    }
  } else if (key == "LotNumber") {
    if(Vendor){
      return LotList?.length
      ? LotList?.filter((item)=>item?.VendorId == Vendor?.value)?.map((item) => {
          return {
            value: item?.VendorId,
            label: item?.LotNumber,
          };
        })
      : [];
    }else{
    return LotList?.length
      ? LotList?.map((item) => {
          return {
            value: item?.VendorId,
            label: item?.LotNumber,
          };
        })
      : [];
    }
  }
  else if (key == "SKUId") {
    return skus?.length
      ? skus?.map((item) => {
          return {
            value: item?.Id,
            label: item?.StockKeepingUnit,
          };
        })
      : [];
  }
}

export const selectStylee = {
  control: (base) => ({
    ...base,
    minHeight: "35px",
    height: "30px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
    whiteSpace: "normal", // Allows text to wrap instead of truncating
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
    whiteSpace: "normal", // Allows full text to display
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

export const LotAuditColumns = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "PurchaseEntryDate", label: "Date", type: "read", priority: 1 },

  {
    key: "VendorName",
    label: "Vendor Name",
    type: "read",
    priority: 3,
  },
  { key: "LotNumber", label: "Lot No", type: "read", priority: 5 },
  {
    key: "PurchaseTotalWt",
    label: "Purchase Total Wt",
    type: "read",
    priority: 4,
  },
  {
    key: "PurchasePackingWt",
    label: "Purchase Packing Wt",
    type: "read",
    priority: 5,
  },
  {
    key: "PurchaseGrossWt",
    label: "Purchase Gross Wt",
    type: "read",
    priority: 6,
  },
  { key: "PurchaseNetWt", label: "Purchase Net Wt", type: "read", priority: 7 },
  { key: "SaleQuantity", label: "Sale Qty", type: "read", priority: 7 },
  { key: "SaleGrossWt", label: "Sale Gross Wt", type: "read", priority: 7 },
  { key: "Quantity", label: "Stock In Qty", type: "read", priority: 7 },
  {
    key: "StockGrossWt",
    label: "Stock In Gross Wt",
    type: "read",
    priority: 7,
  },
  { key: "StockNetWt", label: "Stock Net Wt", type: "read", priority: 7 },
  {
    key: "Difference",
    label: "Difference Gross Wt",
    type: "read",
    priority: 7,
  },
  {
    key: "NetWtDifference",
    label: "Difference Net Wt",
    type: "read",
    priority: 7,
  },
  // { key: "TotalGSTAmount", label: "Action", type: "read", priority: 9 },
];

export const PartyOutstandingColumns = [
  { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
  { key: "VendorName", label: "Vendor Name", type: "read", priority: 1 },

  {
    key: "TotalBalanceGold",
    label: "Balance Fine Gold",
    type: "read",
    priority: 3,
  },
  {
    key: "TotalBalanceSilver",
    label: "Balance Fine Silver",
    type: "read",
    priority: 5,
  },
  {
    key: "TotalBalanceAmount",
    label: "Balance Amount",
    type: "read",
    priority: 4,
  },
  {
    key: "TotalAdvanceAmount",
    label: "Advance Amount",
    type: "read",
    priority: 5,
  },
];

export const formatDate = (inputDate) => {
  const parsedDate = new Date(inputDate);

  if (isNaN(parsedDate)) {
    return "Invalid Date"; // Handle invalid date formats
  }

  const day = String(parsedDate.getDate()).padStart(2, "0");
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Month is zero-based
  const year = parsedDate.getFullYear();

  return `${day}-${month}-${year}`;
};



export const convertDataForUpdate =(data)=>{
 
    return {
      ...data,
      VendorId:+(data?.VendorId || 0) ? {value:data?.VendorId,label:data?.VendorName} : "",
      SKUId:+(data?.SKUId || 0) ? {value:data?.SKUId,label:data?.SKU} : "",
      // SKUId:+(data?.LotNumber || 0) ? {value:data?.VendorId,label:data?.LotNumber} : "",
      // Branch:+(data?.BranchId || 0) ? {value:data?.BranchId,label:data?.BranchName} : "",
      CategoryId:+(data?.CategoryId || 0) ? {value:data?.CategoryId,label:data?.CategoryName} : "",
      ProductId:+(data?.ProductId || 0) ? {value:data?.ProductId,label:data?.ProductName} : "",
      DesignId:+(data?.DesignId || 0) ? {value:data?.DesignId,label:data?.DesignName} : "",
      PurityId:+(data?.PurityId || 0) ? {value:data?.PurityId,label:data?.PurityName} : "",
      StonePieces:+(data?.StonePieces || 0) || +(data?.TotalStonePieces || 0),
      // CollectionId:+(data?.CollectionId || 0) ? {value:data?.CollectionId,label:data?.CollectionNameSKU} : '',
      // PacketId:+(data?.PacketId || 0) ? {value:data?.PacketId,label:data?.PacketName} :"",
      // BoxId:+(data?.BoxId || 0) ? {value:data?.BoxId,label:data?.BoxName} : "",
      // mainstone:{value:data?.BoxId,label:data?.BoxName},
      TotalWeight:(+(data?.TotalWeight || 0))?.toFixed(3),
      Images:data?.Images?.length ? data?.Images?.split(",")?.map((url) => ({ file: null, preview: `https://rrgold.loyalstring.co.in/${url}` })): []
    }


}

export const orderListColumns = [
  { key: "orderNo", label: "Order No", type: "read", priority: 1 },
  { key: "customerName", label: "Customer Name", type: "read", priority: 2 },
  { key: "orderStatus", label: "Order Status", type: "read", priority: 3 },
  {
    key: "metal",
    label: "Metal",
    type: "read",
    priority: 4,
    value: (row) => row?.CategoryName || "N/A", // Fetch selected category
  },
  {
    key: "product",
    label: "Product",
    type: "read",
    priority: 5,
    value: (row) => row?.ProductName || "N/A", // Fetch selected product
  },
  {
    key: "grossWt",
    label: "Gross Wt",
    type: "read",
    priority: 6,
    value: (row) => row?.GrossWt || "0.000", // Fetch gross weight
  },
  { key: "advanceCash", label: "Advance Cash", type: "read", priority: 7 },
  { key: "advanceFine", label: "Advance Fine", type: "read", priority: 8 },
  { key: "orderId", label: "Order ID", type: "read", priority: 9 },
  { key: "orderDate", label: "Order Date", type: "read", priority: 10 },
  { key: "deliveryDate", label: "Delivery Date", type: "read", priority: 11 },
  {
    key: "designName",
    label: "Design Name",
    type: "read",
    priority: 12,
    value: (row) => row?.DesignName || "N/A", // Fetch design name
  },
  {
    key: "pageNo",
    label: "Page No",
    type: "read",
    priority: 13,
    value: (row, index) => index + 1, // Show page number based on pagination
  },
  { key: "catalogName", label: "Catalog Name", type: "read", priority: 14 },
  { key: "insil", label: "Insil", type: "read", priority: 15 },
];

export const customOrderListColumns = [
  { key: "serialNumber", label: "S.No", type: "read", priority: 1 },
  { key: "OrderNo", label: "Order No", type: "read", priority: 2 },
  { key: "CustomerName", label: "Customer Name", type: "read", priority: 3 },
  { key: "Category", label: "Category", type: "read", priority: 4 },
  { key: "Product", label: "Product", type: "read", priority: 5 },
  { key: "Design", label: "Design", type: "read", priority: 6 },
  { key: "Purity", label: "Purity", type: "read", priority: 7 },
  { key: "GrossWt", label: "Gross Wt", type: "read", priority: 8 },
  { key: "StoneWt", label: "Stone Wt", type: "read", priority: 9 },
  { key: "DiamondWt", label: "Diamond Wt", type: "read", priority: 10 },
  { key: "NetWt", label: "Net Wt", type: "read", priority: 11 },
  { key: "Size", label: "Size", type: "read", priority: 12 },
  { key: "Length", label: "Length", type: "read", priority: 13 },
  { key: "Color", label: "Color", type: "read", priority: 14 },
  { key: "Quantity", label: "Quantity", type: "read", priority: 15 },
  { key: "RatePerGram", label: "Rate/Gm", type: "read", priority: 16 },
  { key: "MakingPerGram", label: "Making/Gm", type: "read", priority: 17 },
  { key: "FixedMaking", label: "Fixed Making", type: "read", priority: 18 },
  { key: "FixedWt", label: "Fixed Wt", type: "read", priority: 19 },
  { key: "MakingPercentage", label: "Making %", type: "read", priority: 20 },
  { key: "DiamondPieces", label: "Diamond Pieces", type: "read", priority: 21 },
  { key: "DiamondAmount", label: "Diamond Amount", type: "read", priority: 22 },
  { key: "StoneAmount", label: "Stone Amt", type: "read", priority: 23 },
  { key: "ScrewType", label: "Screw Type", type: "read", priority: 24 },
  { key: "Polish", label: "Polish", type: "read", priority: 25 },
  { key: "Rhodium", label: "Rhodium", type: "read", priority: 26 },
  { key: "SampleWt", label: "Sample Wt", type: "read", priority: 27 },
  { key: "Remarks", label: "Remarks", type: "read", priority: 28 },
  { key: "OrderDate", label: "Order Date", type: "read", priority: 29 },
  { key: "DeliveryDate", label: "Delivery Date", type: "read", priority: 30 },
  { key: "TotalAmount", label: "Total Amount", type: "read", priority: 31 },
];
